import { Translation } from 'types/language/translation.lang';

export let Vn: Translation = {
  charts: {
    loading: 'Đang tải dữ liệu...',
    noData: 'Không có dữ liệu để hiển thị',
    a11yNoValue: 'không có giá trị',
    toolbarExport: 'Xuất',
    toolbarExportPrint: 'In',
    toolbarExportImage: 'Xuất dưới dạng {type}',
  },
  general: {
    copy: 'Copy',
    ok: 'Ok',
    empty: ' ',
    nextFish: 'Next Fish',
    next: 'Next',
    back: 'Back',
    update: 'Update',
    save: 'Save',
    create: 'Create {type}',
    start: 'Start',
    edit: 'Edit {type}',
    add: 'Add {type}',
    submit: 'Submit {type}',
    reset: 'Reset',
    view: 'View',
    close: 'Close',
    loading: 'Loading...',
    delete: 'Delete',
    deleteComment: 'This cannot be undone.',
    yesDelete: 'Yes, delete',
    ignore: 'Ignore',
    accept: 'Accept',
    confirm: 'Confirm',
    search: 'Search',
    notApplicable: 'N/A',
    hide: 'Hide',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    date: 'Date',
    value: 'Value',
    chartWeek: 'Week {row}',
    degrees: 'DEGREES',
    download: 'Download',
    print: 'Print',
    exportScriptsBtn: 'Export Scripts',
    viewResultBtn: 'View Result',
    exportJSONBtn: 'Export JSON',
    exportPDFBtn: 'Export PDF',
    exportCSVBtn: 'Export CSV',
    confidential:
      'CONFIDENTIAL. This document contains Cargill Confidential information. Disclosure, use or reproduction outside Cargill or inside Cargill, to or by those who do not have need to know is prohibited. Copyright © Cargill, Incorporated. All Rights Reserved.',
    product: 'Product',
    site: 'Site',
    from: 'From',
    to: 'To',
    continue: 'Continue',
    remove: 'Remove',
    minimize: 'Minimize menu',
    repeatOrder: ' Repeat Order',
    recalculate: 'Recalculate',
    recalculateIsNeeded: 'Recalculation is needed',
    selectAll: 'Select all',
    moreInfo: 'More Info',
    language: 'Language',
    locale: 'Locale',
    company: 'Company',
    noResults: 'No Results',
    cancel: 'Cancel',
    checkAll: 'Check All',
    clearFilterLabel: 'Clear all filters',
    multiple: 'Multiple',
    release: 'Release',
    clearSelection: 'Clear Selection',
    addLine: 'Add line',
    removeLine: 'Remove line',
    previous: 'Previous',
    pageNotFound: {
      title: 'Page not found',
      description: 'The page you are looking for does not exist or has been moved.',
      goToOverview: 'Go to Overview',
    },
  },
  errorBoundary: {
    retry: 'Thử lại',
    title: 'Đã xảy ra lỗi',
    message: 'Phần này tạm thời không khả dụng. Vui lòng thử lại.',
  },
  features: {
    overview: 'Overview',
    deliveryBoard: 'Delivery Board',
    siteSettings: 'Site Settings',
    orderFeed: 'Order Feed',
    bluViuNutrition: 'bluViu Nutrition',
    fishCheck: 'Fish Check',
    profilesStrategies: 'Profiles & Strategies',
    planningPrognosis: 'Planning & Prognosis',
    feedManagement: 'Feed Management',
    powerBi: 'PowerBi Reports',
    settings: 'Settings',
    seaCloudFileUpload: 'SeaCloud File Upload',
    fileSharing: 'Files',
    shrimpDataUpload: 'Shrimp Data Upload',

    productionSystems: 'Production Systems',
    benchmarkAnalytics: 'Benchmark Analytics',
    selfService: 'Self Service',

    playground: 'Playground',
  },
  login: {
    title: 'You need to sign in to access this',
    loginCustomer: 'Login as Customer',
    loginEmployee: 'Đăng nhập với tư cách nhân viên Cargill',
  },
  selectCompany: {
    intro: "You're connected to multiple customers",
    subtitle: 'Please choose one below:',
  },
  toolbar: {
    changeAccount: {
      customerNumber: 'Number',
      customerName: 'Name',
      signOut: 'Log out',
    },
  },
  overview: {
    dialog: {
      title: 'What is bluViu?',
      readMore: 'Read more',
      paragraphOne:
        "bluViu is Cargill Aqua Nutrition's platform to provide digital services, analytics, insights, optimization and transformation to the aquaculture industries globally.",
      paragraphTwo: 'Our mission is to enable a more sustainable, profitable aquaculture for the future.',
      paragraphThree:
        'bluViu is 100% owned and operated by Cargill, and is managed and developed by a dedicated team. We continuously seek to build relevant solutions, that make us the preferred partner of aquaculture leaders worldwide. We will integrate data streams from supply chains and our customers as well as technology third parties, to provide new insights, optimizations and opportunities for an even better aquaculture. We will build and leverage digital capabilities of Cargill and our partners to benefit our customers, and the world.',
      paragraphFour:
        'We look forward to co-developing this ecosystem together with leading aquaculture partners. If you are curious to learn more - please reach out to us, through your Cargill contact person.',
      yourSites: 'Your sites',
    },

    etaHeader: 'Order ETA',
    loading: 'Loading Order Eta',
    noEtaFound: 'No ETA´s found',
    onTheWay: 'is on the way, ETA',
    notifications: 'Notifications',
    noNotificationsFound: 'No notifications found',
  },
  deliveryBoard: {
    showFactories: 'Show Factories',
    columns: {
      loading: 'Loading',
      onRoute: 'On route',
      delivered: 'Delivered',
      columns: 'Columns',
      map: 'map',
      sites: 'Sites',
      alert: {
        disclaimer:
          'The delivery board is in beta testing - we welcome your feedback and understanding, that this part of the platform is not yet fully developed, so errors and issues could occur.',
      },
    },
    card: {
      dispatchDate: 'Dispatch date:',
      editDistribution: 'Edit distribution',
      readyToDistribute: 'Ready to distribute',
      distribute: 'Distribute',
      edit: 'Edit',
      product: 'Product',
      quantity: 'Quantity',
      viewOrder: 'View Order',
      contactVessel: 'Contact to vessel',
      deliveryNotes: 'Delivery documentation',
      deliveryDocuments: 'Delivery documentation',
      delayed: 'Delayed',
      eta: 'ETA',
    },
  },
  settings: {
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    marketContacts: 'Market Contacts',
    marketContactsText: 'If you have any questions, please contact the order office, or your Cargill contact person.',
    cargillContact: 'Cargill contact person',
    needHelp: 'Need Help?',
    weather: 'Weather',
    snowToggle: 'Let it snow!',
    snowHint: 'Hint: You can also type "christmas" at any time to toggle the snow!',
  },

  siteSettings: {
    navigation: {
      listSites: 'Site',
      generalSettings: 'General Settings',
      inventorySiloManagement: 'Inventory & Silo Management',
      contactDetails: 'Contact Details',
    },
    view: {
      goToSite: 'Go to Site',
    },
    listSites: {
      title: 'Company overview',
      introText: 'Configure site settings.',
      sitesLabel: 'Sites ({value})',
      inactiveSitesLabel: 'Inactive sites ({value})',
      sitesWithoutErpIdLabel: 'Other sites ({value})',
      list: {
        noResults: 'No Results',
        site: 'Site',
        status: 'Status',
        siteErpIdLabel: 'Site ERP ID',
        ofdEnabledLabel: 'OFD',
        automaticOrderingLabel: 'Automatic Ordering',
        ascLabel: 'ASC',
      },
    },
    viewSiteSettings: {
      silos: 'Silos',
      totalMaxCap: 'Total Max Cap, kg',
      numberOfFish: 'Number Of Fish',
      averageWeight: 'Average Weight, g',
    },
    editSiteSettings: {
      title: 'Site Settings for {name}',
      alert: 'Please recalibrate the site',
      emails: 'Emails',
      phoneNumbers: 'Phone numbers',
      siloCapacity: {
        title: 'Silo Settings',
        siloSiteInventory: 'Silo Site Inventory',
        siloCapacityLabel: 'Silo Capacity',
        siloFeedQuantityDateLabel: 'Silo Feed Quantity Date',
        siloFeedQuantityLabel: 'Silo Feed Quantity',
        useFallbackData: 'Use Fallback Data',
        dialog: {
          button: 'Edit Silo Settings',
          title: 'Edit Silo Settings',
          siloCapacityLabel: 'Maximum Silo Capacity',
          siloInventoryUpdatedLabel: 'Inventory Updated',
          siloCurrentInventoryLabel: 'Input Inventory ',
        },
      },
      siloManagement: {
        title: 'Silo Management',
        siloName: 'Silo Name',
        maxCapacity: 'Silo capacity',
        fleetName: 'Fleet Name',
        description: 'Description',
        capacity: 'Capacity',
        disabled: 'Disabled?',
      },
      siloFillPercentage: {
        title: 'Silo Fill Buffer',
        dialog: {
          warning: 'Existing orders will be modified!',
          title: 'Edit Silo Fill Buffer',
          button: 'Edit Silo Fill Buffer',
          capacityBufferPercentage: 'Static Capacity Buffer',
          refillSiloToLabel: 'Refill Silo To',
          setInventoryBufferLabel: 'Use Static Silo Refill',
          dynamicConsumptionBuffer: 'Dynamic Consumption Buffer',
        },
      },
      siteComment: {
        inputLabel: 'Site information Comment',
        headingLabel: 'This information will be sent to the vessel with every Silo Distribution form.',
        title: 'Site Information (intented for vessel)',
        editButton: 'Edit',
      },
      longitudeLatitude: {
        title: 'Longitude & Latitude',
        latitudeLabel: 'Latitude',
        longitudeLabel: 'Longitude',
        dialog: {
          button: 'Edit Location',
          title: 'Edit Longitude & Latitude',
          latitudeLabel: 'Latitude',
          longitudeLabel: 'Longitude',
        },
      },
      temperatureProfile: {
        title: 'Temperature Profile',
        selectYears: 'Select Years',
        temperatureDialog: {
          title: 'Create Temperature Profile',
          subTitle: 'Average temperature',
          graph: 'Graph',
          list: 'List',
        },
      },
      calibrationFeedProgram: {
        dialog: {
          title: 'Edit Feed Program',
          button: 'Edit Feed Program',
        },
      },
      calibration: {
        title: 'Calibration',
        subTitle: 'Calibration inputs',
        isCalibrationCalculatedLabel: 'Is Calibration Calculated',
        hasFeedProgramsLabel: 'Has Feed Programs',
        runButton: 'Run Calibration',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        list: {
          fishSizeStartLabel: 'Fish size start(g)',
          feedIdLabel: 'Feed',
          feedAxMgPerKgLabel: 'Feed ax, mg/kg',
          feedMaizeGlutenPercentLabel: 'Feed maize gluten,(%)',
          relativeMortalityImpactLabel: 'Relative mortality impact',
          relativeGrowthImpactLabel: 'Relative growth impact',
          salmonPricePremiumPerKgGuttedLabel: 'Price premium /kg gutted',
          formulationCostPerTonLabel: 'Formulation Cost /ton',
          customerPricePerTonLabel: 'Customer Price /ton',
        },
        dialog: {
          button: 'Edit Inputs',
          title: 'Edit Calibration',
          name: 'Name',
          stockingFishWeightGLabel: 'Stocking Fish Weight',
          stockingDateLabel: 'Stocking Date',
          harvestFishWeightGLabel: 'Harvest Fish Weight',
          harvestDateLabel: 'Harvest Date',
          harvestCyclebFCRLabel: 'Harvest Cycle bFCR',
          stockingFishWeightErrorLabel: 'Stocking weight cannot be higher than harvest weight',
        },
        warningMessage: {
          caption: 'To enable the inputs and be able to run a calibration please ensure that:',
          reasonOne: 'Site has latitude and longitude configured',
          reasonTwo: 'Site has temperature profile set',
          reasonThree: 'Contact an admin to make sure the site has the correct mappings',
        },
      },
      recommendedProducts: {
        title: 'Recommended Products',
        noResults: 'No products found',
        product: {
          productName: 'Product Name',
          expirationDate: 'Expiration Date',
        },
        dialog: {
          title: 'Edit Recommended Products',
          button: 'Edit Recommended Products',
        },
      },
      orderFreeDelivery: {
        title: 'Order Free Delivery',
      },
    },
  },
  orderFeed: {
    asc: 'ASC',
    navigation: {
      orderSupplyPlan: 'My Supply Plan',
      orderDistribution: 'Distribution',
      orderHistory: 'Order History',
      createOrder: 'Create Custom Order',
      listStarvation: 'Starvation',
      purchaseHistory: 'Purchase History',
      timeline: 'Timeline',
    },
    alert: {
      maintenance: 'Ordering is disabled due to maintenance',
      endsAt: 'Ends At: ',
      duplicate: 'One or more order lines is a duplicate',
      duplicateLine: 'This line is identical to another line in the order.',
      shippingSchedule: 'Dispatch date is no longer available, please update dispatch date',
      productDateRange: 'Product no longer exists in the price list for the selected dispatch date',
    },
    ofdMySupplyPlan: {
      ordersLabel: 'Orders',
      inputSettingsLabel: 'Input Settings',
      ofdActive: 'OFD (Order free delivery) active',
      settingsUnavailableTitle: 'OFD settings are temporarily unavailable',
      settingsUnavailableMessage: 'We could not load OFD settings right now. You can retry, or continue using the rest of the page.',
      retrySettingsFetch: 'Retry',
      viewTemporarilyUnavailable: 'This section is temporarily unavailable',
      recoverView: 'Recover view',
      todayLabel: 'Today',
      dayOfNextDelivery: 'Day of next delivery',
      tooltipContent: 'Expected inventory during the ',
      cards: {
        startingInventory: 'Starting inventory',
        consumptionRate: 'Consumption rate',
        consumption: 'Consumption',
        orderDelivered: 'Order delivered',
        status: 'Needs manual update',
        capacity: 'of capacity',
        day: '/ day',
        runOut: 'When inventory is expected to run out:',
        nextDeliveryNoDate: 'No date available',
        contactCustomerService: 'Contact Customer service',
        lowInventory: 'Low inventory!',
        endingInventory: 'Ending inventory',
        confirmedDelivery: 'Confirmed delivery:',
        forecastedDelivery: 'Forecasted delivery:',
        buttons: {
          openInventory: 'Open inventory',
          openConsumption: 'Open consumption',
        },
        drawer: {
          feedInventory: 'Feed inventory',
          calculateConsumption: 'Manage your calculated consumption rate to keep it accurate.',
          dailyConsumptionRate: 'Daily Consumption Rate',
        },
        orderStatusInfo: {
          days: 'days',
          day: 'day',
          forecast: {
            forecastQuestionTitle: 'Why was this order generated?',
            forecastAnswerContent:
              'Based on your current inventory of {stock} kg and consumption rate, we forecast a delivery of {units} kg of feed to maintain stock above the buffer.',
            forecastChangesToOrderTitle: 'Date of auto-confirmation',
            forecastChangesToOrderContent: {
              bold: 'We will send out a confirmation once the order is confirmed.',
              message:
                '{date} ({daysLeft} {daysLeftText} left - {daysBeforeDispatch} {daysBeforeText} before dispatch) {br}{br} The order will be automatically adjusted up until then to maintain accuracy. ',
            },
          },
          skipped: {
            skippedQuestionTitle: 'Why was this order skipped?',
            skippedAnswerContent:
              'Based on your inventory, we forecast that you do not need feed delivered on this shipment, because you have adequate inventory to be above buffer until the following shipment.',
          },
          open: {
            openQuestionTitle: 'Why is this an open slot?',
            openAnswerContent:
              'We do not allow forecasted orders between confirmed orders. {br} You can still create a new order on this available dispatch date.',
            cannotCreateOrderQuestion: 'Why is the button disabled?',
            cannotCreateOrderAnswer:
              'The system has not generated an order for this shipment. It is now past the deadline for automated order creation. Please contact customer service if you cannot yourself create an order on this shipment. ',
          },
          confirmed: {
            changesTitle: 'Changes to order',
            changesContent: 'Last day to make changes: {date} ({daysLeft} days left). {br} After this no changes will be possible.',
            orderCommentTitle: 'Order Comment',
          },
        },
      },
      sitesLabel: 'Sites ({value})',
      inactiveSitesLabel: 'Inactive sites ({value})',
      orders: {
        totalOrderQuantity: 'Total Order quantity',
        orderQuantity: 'Order Quantity',
        dispatchDate: 'Dispatch Date',
        selectProduct: 'Select Product',
        methodOfDelivery: 'Method Of Delivery',
        removeOrderLine: 'Remove Order Line',
        addOrderLine: 'Add Order Line',
        customerReference: 'Customer Reference Number',
        orderComment: 'Order Comment',
        orderDetails: 'Order Details (optional)',
        distributionDetails: {
          title: 'Order #{orderNumber} - Distribution Details',
          showTooltip: 'Show distribution details',
          showDistribution: 'Hiển thị phân bổ',
          updatedAt: 'Updated at',
          updatedBy: 'Updated by',
          extraStorage: 'Extra Storage',
          product: 'Product',
          itemNumber: 'Item number',
          quantity: 'Quantity',
          silo: 'Silo',
        },
        availableProducts: 'Show Available Products',
        preferredProducts: 'Show Preferred Products',
        modals: {
          forecastDialog: {
            title: 'Forecasted',
            quantityMessage:
              'This quantity will continiously change and adapt to your supply until confirmed, in order to provide the most accurate forecasts.',
            overridingMessage: 'By overriding this forecast you will be taking manual control of all orders up until {date}.',
            existingForecastMessage: 'We never make forecasts between existing orders.',
            remainingForecastMessage: 'All remaining forecasted orders will automatically be adjusted to fit your changes.',
            calibrateMessage: 'We always recommend you to {calibrate} before changing an order for most accurate forecasts.',
            overrideButton: 'Override and create order',
            calibrateSettings: 'calibrate your settings',
          },
          confirmedDialog: {
            title: 'Confirmed',
            updateButton: 'Update',
            deleteButton: 'Delete order',
            skipButton: 'Skip this dispatch',
            unSkipButton: 'Confirm',
            message: 'We always recommend you to {underlined} before changing an order for most accurate forecasts.',
            underlinedMessage: 'callibrate your settings',
            deleteOrder: {
              deletionReason: 'Select the deletion reason',
              deleteOrderMessage: 'Are you sure that you want to delete this order?',
            },
            skipRecommendation: {
              skipRecommendationConfirmationMessage: 'Are you sure that you want to skip this dispatch date ({date})?',
              unSkipRecommendationMessage: 'Are you sure that you want to un-skip this dispatch date ({date})?',
              tooltipLabel:
                'Un-skip this manually skipped dispatch date. Once un-skipped, the system might come up with an order forecast for this date.',
            },
          },
          openDialog: {
            title: 'Open Slot',
          },
          skippedDialog: {
            title: 'Skipped ({type})',
          },
          viewFeedProgramsDialog: {
            viewFeedProgramsBtn: 'View feed programs',
            noFeedStrategyAssigned: 'No feed strategy assigned.',
            columns: {
              fishGroup: 'Fish group',
              latestWeight: 'Latest weight',
              feedProgram: 'Feed program',
              harvestTarget: 'Harvest target',
            },
            options: {
              transferWeights: 'Transfer weights',
              feeds: 'Feeds',
            },
          },
        },
        filters: {
          confirmed: 'Confirmed',
          forecast: 'Forecast',
          skipped: 'Skipped',
        },
        list: {
          delivered: 'Delivered',
          orderStatus: 'Order status',
          orderNumber: 'Order Number',
          customerOrderReference: 'Customer Order Reference',
          autoConfirm: 'Auto-confirm',
          dispatchDate: 'Dispatch date',
          deliveryDate: 'Delivery date',
          quantity: 'Quantity',
          changes: 'Changes?',
          notPossible: 'Not possible',
          days: '{days} days',
          day: '{days} day',
          today: 'Today',
          skipped: 'Skipped ({type})',
          forecast: 'Forecast',
          createOrderBtn: 'Create Order',
          createNewOrderBtn: 'Create New Order',
          adjustSettings: 'Adjust settings',
          overrideForecastBtn: 'Override forecast',
          unskipBtn: 'Un-skip',
          manual: 'Manual',
          forecasts: 'Forecasts',
          vesselName: 'Vessel',
          plantName: 'Loading plant',
          orderDetails: 'Order details',
          arrivalDate: 'Arrival date',
          arrivalTime: 'Arrival time',
          orderCreationDate: 'Order creation date',
          body: {
            product: 'Product',
            quantityTitle:
              'This quantity will continiously change and adapt to your supply until confirmed, in order to provide the most accurate forecasts.',
            titleQuestion: 'Quantity not matching up with your plan?',
            messageAnswer:
              'We recommend to recalibrate your settings before making changes to OFD forecasts, in order to improve accuracy.',
            productNotAvailable: 'Product not available',
            productNotAvailableMessage: '- Product not available.',
            productNotAvailableTooltipMessage: 'Contact customer support to add it or add a different feed.',
          },
          productsUnavailableAtPlantTitle: 'Products unavailable at plant',
          productsUnavailableAtPlantMessage:
            'The following products are not included in the recommendations because no plant on your shipping schedule can supply them:',
          productsUnavailableAtPlantInstruction: 'Contact customer support to arrange supply.',
          productsUnavailableAtPlantShow: 'Show {count} products',
          productsUnavailableAtPlantHide: 'Hide products',
        },
      },
      feedInventory: {
        tooltip: {
          events: {
            delivery: 'Delivery',
            forecast: 'Forecast',
            manualUpdate: 'Manual update',
            consumption: 'Consumption',
            expectedConsumption: 'Exp. Consumption',
          },
        },
      },
      inputSettings: {
        feedInventoryTab: {
          label: 'Feed inventory',
          headerText: 'Update your inventory every 90 days in order to receive most accurate feed forecast.',
          lastUpdated: 'Last manual update: ',
          inventoryLevelLabel: 'Enter your latest measured inventory level ',
          inventoryLevelNoDeliveryLabel: 'Enter today’s starting inventory level ',
          feedingStatusLabel: 'When was the inventory measured?',
          feedingStatusDiscloser: '(You have an expected delivery today)',
          confirmedDeliveryLabel: 'Estimated addition based on delivery: ',
          finalCalculatedLabel: 'Final calculated inventory at end of day based on input: ',
          estimatedSubtractionLabel: 'Estimated subtraction based current consumption rate:',
          estimatedSubtractionNoDeliveryLabel: 'Estimated subtraction today based current consumption rate:',
          beforeDelivery: 'Before delivery',
          afterDelivery: 'After delivery',
          daysAgo: 'days ago',
          percentage: '({percentage} of capacity)',
          dialog: {
            title: 'How was this calculated?',
            explanation:
              'Since the last inventory update, several events have impacted your current stock level. Below is a detailed log showing exactly how we arrived at the current inventory figure.',
            log: {
              title: 'Inventory log',
              day: 'Day',
              dataInput: 'Data input',
              event: 'Event',
              adjustment: 'Adjustment',
              startInventory: ' Start inventory',
              today: 'Today’s starting inventory',
              emptyArray: 'Starting inventory',
            },
          },
        },
        dailyConsumptionRateTab: {
          label: 'Daily Consumption Rate',
          headerText: 'Manage your calculated consumption rate to keep it accurate.',
          day: '/day',
          days: 'days',
          recommended: 'Historical average (Recommended)',
          manual: 'Manual adjustment (Not recommended) ',
          sealice: 'Sea lice treatment mode',
          sealiceTooltip: 'Historical average excluding starvation days due to sea lice treatment',
          calculationMethod: 'Calculation method: ',
          prognosis: 'EGI prognosis (today) ',
          daysHistoricalAverage: 'Days used as historical average:',
          sliderTitle: 'Percentage offset',
          selectedCalculationLabel: 'Select calculation method',
          tooltipInfo:
            'The base forecast can be adjusted either by a percentage you set, or a percentage we calculate based on consumption average.',
          tooltipMethod:
            'Your average consumption, and our prediction model are compared, and we use the actual consumption to adjust the forecast up or down for the next 45 days.',
          tooltipPrognosis:
            'Your forecast, before adjustment, and how many days we are averaging to adjust the model. Shorter time=more responsive, longer time=more stable.',
          editRecommended: {
            historicalAverage: 'Historical average',
            sliderHeader: 'Select amount of past days to use as average for calculation (3-30 days):',
            title: 'Days',
          },
          editPrognosis: {
            prognosis: 'Manual adjustment',
            alert:
              'You have now switched from the recommended calculation. This will likely be less accurate and needs to be revisited.',
            sliderHeader: 'Adjust prognosis by setting a percentage offset:',
          },
          feedStrategyList: {
            title: 'View Feed Strategy',
            fromWeightLabel: 'From Weight',
            nameLabel: 'Product Name',
            editBtn: 'Edit Feed Strategy',
          },
        },
        feedReserveTab: {
          label: 'Feed Reserve',
          headerText:
            'In case of order delay, feed reserve will aim to keep your desired amount of feed in the inventory at all times.',
          adaptiveBufferTitel: 'Adaptive buffer',
          adaptiveBuffer: 'Adaptive ',
          daysConsumption: 'days consumption',
          totalBufferText: 'Based on: Adaptive buffer + Static buffer',
          totalBufferTitel: 'Total buffer',
          adaptiveBufferText: 'Based on your current consumption, {days} days worth of feed equals {increasedDays}.',
          staticBuffer: 'Static buffer',
          staticTitleBuffer: 'Static',
          additionalBufferText: 'Adds an additional amount of feed to your feed reserve as a margin to the adaptive buffer.',
          maxCapacity: 'Max capacity: ',
          days: 'Days',
        },
        preferencesTab: {
          label: 'Preferences',
          headerText: 'Manage your general preferences for the OFD system.',
          minimumQuantityTitle: 'Minimum Forecasted Order Quantity',
          orderFrequency: 'Order Frequency',
          minimumQuantityText:
            'No orders will be placed with volume smaller than this. The site will be supplied with fewer and larger orders.',
          minimumQuantity: 'Minimum quantity',
          minimumOrderFrequencyText: 'It must be a number in the range 1-30',
          minimumOrderFrequency: 'Order Frequency',
          quantityErrorMessage: 'Quantity must be a multiple of {value}',
          minimumValueErrorMessage: '{label} must be at least {minValue}',
          rangeValueErrorMessage: 'Frequency must be between 1 and 30',
        },
      },
      timeline: {
        fortyFiveDays: '45 days',
        twentyOneDays: '21 days',
      },
    },
    listOrderSupplyPlan: {
      title: 'My Supply Plan',
      filter: {
        siteLabel: 'Select Site',
        sitesLabel: 'Select Sites',
        fromDateLabel: 'From Date',
        toDateLabel: 'To Date',
        options: {
          isOfdEnabled: 'OFD Enabled',
          noSiloData: 'Missing Silo Data',
          noErpAddress: 'Missing ERP Address',
        },
      },
      siteList: {
        active: 'Sites',
        inactive: 'Inactive sites',
        noResults: 'No sites found',
        siteNameLabel: 'Site',
        nextOrderLabel: 'Next Order',
        thirtyDaysPlan: '30 Days Plan',
        inventoryLabel: 'Inventory',
        ofdLabel: 'OFD',
        ofdEnabledTooltip: 'OFD {ofdVersion} is enabled for this site',
        ofdAutomaticOrderingTooltip: 'OFD {ofdVersion} and automatic ordering are enabled for this site',
        siteIntensityLabel: 'Site intensity',
        supplyWeekLabel: 'Supply wk {weekValue}',
        weekConsumptionLabel: 'Weekly Consump.',
        requireActionLabel: 'Requires action',
        scheduleTooShort: 'Schedule too short',
        productNotAvailable: 'Product not available',
        inventoryUpdateTooltip: 'This site may require additional attention',
      },
      orderList: {
        recommendation: 'Recommendation',
        noResults: 'No orders found',
        orderNumberLabel: 'Order Number',
        customerOrderReferenceLabel: 'Customer Order Reference',
        requestedDeliveryDateLabel: 'Dispatch Date',
        totalOrderQtyLabel: 'Order Quantity',
        productLabel: 'Product',
        quantityLabel: 'Quantity',
        orderedLabel: 'Ordered',
        amountLabel: 'Amount',
        changePossibleLabel: 'Change Possible?',
        noChangeableLabel: 'No',
        remainingDaysLabel: 'days left',
        remainingDayLabel: 'day left',
        createOrder: {
          availableProductsGroup: 'Available Products',
          preferredProductsGroup: 'Preferred Products',
          customerReference: 'Customer Reference Number',
          methodOfDelivery: 'Method Of Delivery',
          orderComment: 'Order Comment',
          removeOrderLine: 'Remove Order Line',
          addOrderLine: 'Add Order Line',
          editOrderDetails: 'Edit Order Details',
          productDescription: '{type}, Packaging: {packaging}',
          orderCreated: 'Created order',
        },
      },
      statusList: {
        products: {
          withoutAssortmentLabel: 'Products Without Assortment',
          withoutDensityLabel: 'Products Without Density',
          correctiveActionLabel: 'Corrective Actions',
        },
        correctiveActions: {
          fixProductDensity: 'Check product density in M3. Using P&P service check why listed products are recommended by SeaCloud.',
          fixCustomerAssortment:
            'Check why listed products are not in customer assortment in M3. Using P&P service check why listed products are recommended by SeaCloud.',
          fixSiloSensor: 'Contact customer to resolve issue with the silo sensor.',
          fixSiteLinkToErp: 'Use User admin to link site to a relevant M3 site.',
          fixManuallySpecifiedSiloInventory: 'Silo Inventory must be updated manually.',
          specifySiteSiloInventory: 'Specify silo capacity and inventory.',
          general: 'Contact your customer representative to fix highlighted issues.',
          enableOrderFreeDelivery: 'Enable Order free delivery for site.',
        },
      },
      createOrderDialog: {
        title: 'Create Order',
        recommendedTitle: 'Create Recommended Order',
        methodOfDeliveryLabel: 'Method Of Delivery',
        customerOrderNumberLabel: 'Reference Number',
        orderCommentLabel: 'Order Comment',
      },
    },
    orderDistribution: {
      filter: {
        fromDateLabel: 'From Date',
        toDateLabel: 'To Date',
      },
      infoText: 'NOTE: silo distribution closes 3 hours before boat’s arrival to site',
      distribute: 'Distribute',
      readyForDistribution: 'Ready for distribution',
      distributed: 'Distributed',
      list: {
        siteName: 'Site name',
        dispatchDate: 'Dispatch date',
        deliveryDate: 'Delivery date',
        orderQuantity: 'Order quantity',
        editDisabled: 'It’s no longer possible to edit the distribution. Please contact the vessel directly for changes',
        vesselName: 'Delivery method',
        configHasChanged: 'The settings for this distribution has changed',
        body: {
          orderNumber: 'Order number',
          quantity: 'Quantity',
          distributedQuantity: 'Distributed quantity',
          productName: 'Product name',
          siloName: 'Silo name',
        },
      },
      createDistribution: {
        infoText: 'NOTE: silo distribution closes 3 hours before boat’s arrival to site',
        distribute: 'Distribute',
        capacityAlert: 'Quantity exceeds silo capacity',
        productAlert: 'Product quantity exceeds availability',
        product: 'Product',
        quantity: 'Quantity',
        additionalNotes: 'Additional Notes (optional)',
        comments: 'Site Information (Will be sent to vessel)',
        editable: 'Editable from Site Settings',
        overview: {
          list: {
            siteName: 'Site name',
            dispatchDate: 'Dispatch Date',
            deliveryDate: 'Delivery Date',
            orderQuantity: 'Order quantity',
            body: {
              product: 'Product',
              ordered: 'Ordered',
              toDistribute: 'To distribute',
              distributed: 'Distributed',
            },
          },
        },
        form: {
          extraStorage: 'Extra Storage',
          pointOfContact: 'Point of Contact',
          comments: 'Notes to vessel',
          removeLine: 'Remove Line',
          addLine: 'Add Line',
          quantity: 'Quantity',
          product: 'Product',
          maxCapacity: 'Max Capacity',
          configHasChanged: 'The settings for this silo has changed',
        },
      },
    },
    orderHistory: {
      title: 'Order History',
      search: 'Order No.',
      dateRange: 'Orders from {fromDate} to {toDate}',
      ordersList: {
        noResults: 'No orders found, check dates',
        orderNumberLabel: 'Order No.',
        orderDateLabel: 'Order Date',
        dispatchDate: 'Dispatch Date',
        status: 'Status',
        orderedQuantity: 'Ordered Quantity',
        invoicedQuantity: 'Invoiced Quantity',
        deliveredQuantity: 'Delivered Quantity',
        deliveryMethod: 'Delivery Method',
        articleNumber: 'Article Number',
        lineNumber: 'Line Number',
        product: 'Product Name',
        deliveryNotes: 'Delivery documentation',
        deliveryDocuments: 'Delivery notification documents',
        siteName: 'Site',
        deliveryDateLabel: 'Dispatch Date',
        totalOrderQtyLabel: 'Amount',
      },
      filters: {
        fromDateLabel: 'From date',
        toDateLabel: 'To date',
        monthView: 'Period',
        pastMonth: 'Past month',
        pastThreeMonth: 'Past three months',
        pastSixMonth: 'Past six months',
        siteLabel: 'Select site',
        total: 'Total',
        allSites: 'All sites',
        clearSites: 'Clear sites',
      },
    },
    purchaseHistory: {
      title: 'Purchase History',
      chartTitle: 'Product Quantity Breakdown',
      chartQuantity: 'Total product quantity',
      groupType: 'Group Type',
      product: 'Product',
      family: 'Family',
      noResults: 'No Results',

      monthView: 'Period',
      pastMonth: 'Past Month',
      pastThreeMonth: 'Past Three Month',
      pastSixMonth: 'Past Six Month',
      siteLabel: 'Select Site',
      total: 'Total',
      allSites: 'All Sites',
      clearSites: 'Clear Sites',
    },
    viewOrder: {
      title: 'Order #{orderNumber}',
      contactBtn: 'Contact EWOS',
      changeableStatusClosed: 'This order is closed and cannot be edited',
      changeableStatusOpen: 'This order is open for edit until {date}',
      deliveryNotes: 'Delivery documentation',
      deliveryDocuments: 'Delivery notification documents',
      orderHistory: {
        updatedByLabel: 'Updated By',
        updatedAtLabel: 'Updated At',
        orderNumberLabel: 'Order Number',
        title: 'Silo distribution',
        siloNameLabel: 'Silo name',
        itemNameLabel: 'Item name',
        itemNumberLabel: 'Item number',
        quantityLabel: 'Quantity',
      },
      orderLinesList: {
        title: 'Products Ordered',
        itemNameLabel: 'Product',
        itemNumberLabel: 'No.',
        requestedDispatchDateLabel: 'Dispatch Date',
        orderQuantityLabel: 'Quantity',
        repeatOrderBtn: 'Repeat Order',
      },
      orderDeliveriesList: {
        itemNumberLabel: 'Product',
        orderQuantityLabel: 'Quantity',
      },
      orderInfo: {
        title: 'Order info',
        orderNumberLabel: 'Order no.',
        orderDateLabel: 'Order date',
        requestedDeliveryDateLabel: 'Preferred dispatch date',
        customersOrderNumberLabel: 'Reference no.',
        orderCommentsLabel: 'Comments',
        asc: 'ASC',
        yes: 'Yes',
      },
      invoiceInfo: {
        title: 'Invoice info',
        customerNameLabel: 'Customer name',
        customerNoLabel: 'Customer no.',
        invoiceNumberLabel: 'Invoice no.',
      },
      deliveryInfo: {
        title: 'Delivery info',
        transportCompanyNameLabel: 'Delivery method',
        deliveryDateLabel: 'Dispatch date',
        warehouseNameLabel: 'Shipped from',
        address1Label: 'Deliver to site',
        statusLabel: 'Status',
        etaLabelLabel: 'Eta',
        orderStatus: {
          received: 'Received',
          confirmed: 'Confirmed',
          delivered: 'Delivered',
          invoiced: 'Invoiced',
          canceled: 'Canceled',
          unknown: 'Unknown',
        },
      },
      productDeclaration: {
        title: 'Product Declaration ',
        productNumber: 'Product number: ',
        produced: 'Produced: ',
        bestBefore: 'Best before: ',
        series: 'Series: ',
        customer: 'Customer: ',
        orderNumber: 'Order number: ',
        deliveredQuantity: 'Delivered quantity: ',
        producer: 'Producer: ',
        producedBy: 'Produced by: ',
        designation: 'Designation: ',
        instruction: 'Instructions: ',
        analyticalComponents: 'Analytical components: ',
        additives: 'Additives, per kg: ',
        vitamins: 'Vitamins: ',
        micronutrients: 'Micronutrients: ',
        pigments: 'Pigments: ',
        noBatches: 'No batches for order line',
        ingredients: 'Composition of feed materials',
        asc: {
          title: 'ASC Conforming feed produced under the Mass Balance Production Model',
          info: '(www.asc-aqua.org). ASC ID number: {siteNumber}',
        },
      },
    },
    editOrder: {
      title: 'Edit Order #{orderNumber}',
      deleteOrderBtn: 'Delete Order',
      saveOrderBtn: 'Save Order',
      orderLinesList: {
        addOrderLine: 'Add Order Line',
        removeOrderLine: 'Remove Order Line',
        orderDetailsLabel: 'Order Details',
        availableProducts: 'Show Available Products',
        preferredProducts: 'Show Preferred Products',
        itemNameLabel: 'Product',
        itemNumberLabel: 'Number',
        methodOfDeliveryLabel: 'Method of delivery',
        orderCommentLabel: 'Order Comments',
        orderQuantityLabel: 'Quantity',
        requestedDeliveryDateLabel: 'Dispatch Date',
        packagingLabel: 'Packaging',
      },
      editRecommendationOrder: {
        title: 'Edit Order',
        save: 'Create Order',
        add: 'Add Product',
      },
    },
    listStarvation: {
      title: 'Starving Periods',
      starvingPeriodList: {
        noResults: 'No Results',
        globalSiteIdLabel: 'Site',
        selectFishGroups: 'Select Fish Groups',
        fishGroupNameLabel: 'Fish Group / Unit',
        startDateLabel: 'Start Date',
        endDateLabel: 'End Date',
        comment: 'Comment',
      },
      commentReason: {
        liceTreatment: 'Lice Treatment',
        harvest: 'Harvest',
        farmMaintenance: 'Farm Maintenance',
        fishMovement: 'Fish Movement',
        otherReason: 'Other Reason',
        invalid: 'Invalid',
      },
    },
    orderFeedEdit: {
      invalid: 'Select Reason',
      delousing: 'Delousing',
      disease: 'Disease',
      increasedAppetite: 'Increased Appetite',
      reducedAppetite: 'Reduced Appetite',
      delayedDelivery: 'Delayed Delivery',
      silosAreFull: 'Silos are Full',
      silosAreEmpty: 'Silos are Empty',
      scheduleChange: 'Schedule Change',
      harvest: 'Harvest',
      changeOfTheSupplier: 'Change of the Supplier',
      fleetChange: 'Fleet Change',
      noneOfTheAbove: 'None of the Above',
    },
    timeline: {
      title: 'Timeline',
      graph: {
        date: 'Date',
        datetime: 'Today',
        quantity: 'Quantity',
        inventory: 'Inventory',
        dailyConsumption: 'Daily Consumption',
        siloCapacity: 'Silo Capacity',
        orderQuantity: 'Order Quantity',
        recommendOrderQuantity: 'Recommend Order Quantity',
        factoryVessel: 'Factory - Vessel',
        plannedStarvation: 'Planned Starvation',
        requestedDeliveryDate: 'Requested Delivery Date',
        unplannedStarvation: 'Unplanned Starvation',
      },
      starvation: {
        list: {
          globalSiteIdLabel: 'Site',
          selectFishGroups: 'Select Fish Groups',
          fishGroupNameLabel: 'Fish Group / Unit',
          startDateLabel: 'Start Date',
          endDateLabel: 'End Date',
        },
      },
      capacityBufferPercentage: 'Static Capacity Buffer',
      refillSiloToLabel: 'Refill Silo To',
      setInventoryBufferLabel: 'Use Static Silo Refill',
      dynamicConsumptionBuffer: 'Dynamic Consumption Buffer',
      siloTitle: 'Silo Fill Buffer',
      infoCapacityBufferPercentage:
        "Adds the given percentage of the site's silo capacity to the buffer. Recommendations will aim to keep the inventory above the buffer amount between deliveries.",
      infoDynamicConsumptionBuffer:
        'Adds the given number of days of average expected feed consumption to the silo buffer. Recommendations will aim to keep the inventory above the buffer amount between deliveries.',
      infoRefillSiloToLabel:
        "Recommendations will aim to refill the silos to the given percentage of the site's silo capacity on every delivery.",
    },
  },
  profilesStrategies: {
    generalTitle: 'General',
    ownerTitle: 'Owner',
    linesTitle: 'Lines',
    feedStrategy: 'Feed Strategy',
    label: {
      name: 'Name',
      feedStrategyActive: 'Feed strategy is active',
      feedStrategyTemporary: 'Feed strategy is temporary',
      startWeightLabel: 'Start weight',
      product: 'Product',
      period: 'Period',
      average: 'Average',
      profileType: 'Profile Type',
      periodisation: 'Periodisation',
      profileSubType: 'Profile SubType',
      profile: 'Profile',
    },
    menuItem: {
      market: 'Market',
      company: 'Company',
      site: 'Site',
      connectedFishGroups: 'Number Of Connected Fish Groups',
    },
    navigation: {
      listFeedStrategies: 'Feed Strategies',
      listProfiles: 'Profiles',
      editMarketProfiles: 'Market Profiles',
      editSiteProfiles: 'Site Profiles',
    },
    listFeedStrategies: {
      title: 'Feed Strategies',
      createButton: 'Create Strategy',
      isUserAuthorized: 'A Cargill administrator can give you access to this site',
      list: {
        noResults: 'No feed strategies found',
        nameLabel: 'Name',
        numberOfConnectedFishGroupsLabel: 'No. Fish Groups',
        activeLabel: 'Active',
        isTemporaryLabel: 'Temporary',
      },
      filters: {
        state: {
          title: 'State',
          active: 'Active',
          isTemporary: 'Temporary',
        },
      },
    },
    listProfiles: {
      title: 'Profiles',
      createButton: 'Create Profile',
      list: {
        noResults: 'No profiles found',
        nameLabel: 'Name',
        activeLabel: 'Active',
        isTemporaryLabel: 'Temporary',
        numberOfConnectedFishGroupsLabel: 'No. Fish Groups',
      },
      filters: {
        state: {
          title: 'State',
          active: 'Active',
          isTemporary: 'Temporary',
        },
      },
    },
    createFeedStrategies: {
      title: 'Create Feed Strategy',
      duplicateProfiles: 'Starting weight value is duplicated',
      startWeightValue: 'First start weight value should start at zero',
    },
    editFeedStrategies: {
      title: '{name}',
      duplicateProfiles: 'Starting weight value is duplicated',
      startWeightValue: 'First start weight value should start at zero',
      productInactive: 'Product inactive, please select from the list',
    },
    createProfiles: {
      title: 'Create Profile',
      profiles: {
        egi: 'EGI',
        efi: 'EFI',
        mort: 'Mortality',
      },
    },
    editProfiles: {
      title: '{name}',
      profileToggle: {
        active: 'Profile is active',
        temporary: 'Profile is temporary',
        circular: 'Profile is circular',
        input: 'Profile is from Input',
      },
    },
    editMarketProfiles: {
      title: 'Manage market profiles',
      submitButton: 'Submit profiles',
      list: {
        noResults: 'No profiles found',
        efiLabel: 'Efi',
        egiLabel: 'Egi',
        feedStrategyLabel: 'Feed Strategy',
        mortalityLabel: 'Mortality',
        smoltTypeNameLabel: 'Smolt Type',
        speciesNameLabel: 'Species',
      },
    },
    editSiteProfiles: {
      title: 'Manage site profiles',
      siteLabel: 'Site',
      selectSite: 'Select site',
      harvestTargetLabel: 'Harvest Target',
      weight: 'Weight',
      date: 'Date',
      defaultProfiles: 'Default Profiles',
      list: {
        noResults: 'No profiles found',
        efiLabel: 'Efi',
        egiLabel: 'Egi',
        feedStrategyLabel: 'Feed Strategy',
        mortalityLabel: 'Mortality',
        smoltTypeNameLabel: 'Smolt Type',
        speciesNameLabel: 'Species',
      },
    },
  },
  planningPrognosis: {
    navigation: {
      listSites: 'Sites',
      listNotifications: 'Notifications',
    },
    createVirtualFishGroup: {
      stockingDate: 'Stockingdate',
      name: 'Name',
      numberOfFish: 'Number of fish',
      stockingWeight: 'Stocking weight, g',
      species: 'Species',
      smoltType: 'Smolt type',
      strain: 'strain',
    },
    calculator: {
      egiProfile: 'EGI',
      efiProfile: 'EFI',
      mortProfile: 'Mortality',
      tempProfile: 'Temperature',
      fishGroup: 'Fish Group',
      calculate: 'Calculate',
      startDate: 'Start Date',
      latitude: 'Latitude',
      quantity: 'Number of Fish',
      species: 'Species',
      meanWeight: 'Mean Weight, g',
      harvestTarget: 'Harvest Target: 5.5kg',
    },
    listSites: {
      title: 'Sites',
      list: {
        nameLabel: 'Site',
        activeFishGroupsLabel: 'Active Fish Groups',
        biomassLabel: 'Biomass, kg',
        noResults: 'No sites found',
        noFishLabel: 'No. Fish',
        avgWeightLabel: 'Avg. Weight, g',
      },
      dialogMultiProfiles: {
        dialogButton: 'Edit Sites',
        title: 'Edit Sites',
      },
      dialogMultiTempProfiles: {
        dialogButton: 'Edit Temporary Profiles',
        title: 'Edit Temporary Profiles',
      },
    },
    viewSite: {
      title: '{siteName}',
      activitiesTitle: 'Latest Forecast Activities',
      fishGroupList: {
        editMultiple: 'Edit multiple fish groups',
        noResults: 'No fish groups found',
        lastFishGroupIdFromXmlLabel: 'No.',
        fishGroupNameLabel: 'Name',
        unitNameLabel: 'Unit',
        smoltNameLabel: 'Smolt',
        stockingDateLabel: 'Date',
        stockingWeightLabel: 'Stocking, g',
        currentWeightLabel: 'Current, g',
        accEgiLabel: 'Egi',
        accEfiLabel: 'Efi',
        hasTemporaryLabel: 'Temp.',
        mortality: 'Mortality',
        feedStrategy: 'Feed Strategy',
        createVirtualFG: 'Create Virtual Fish Groups',
      },
      forecastList: {
        noResults: 'No forecast activities found',
        userIdLabel: 'User',
        dateLabel: 'Date',
        commentLabel: 'Comment',
      },
      dialogForecast: {
        dialogButton: 'Save Forecast',
        title: 'Save Forecast',
        commentLabel: 'Comment',
      },
      planningPrognosisTabs: {
        fishGroups: 'Fish groups',
        virtual: 'Virtual',
        harvest: 'Harvested',
        changeProfiles: 'Change profiles',
        calculator: 'Calculator',
      },
    },
    viewFishGroup: {
      title: '{unitName} - {fishGroupName}',

      snapshotsList: {
        title: 'Snapshot',
        noResults: 'No snapshots found',
        nameLabel: 'Name',
        realLabel: 'Actual',
        prognosisLabel: 'Prognosis',
        planLabel: 'Planned',
        showLabel: 'Show',
        // Forecast: 'Forecast',
      },
      profileList: {
        title: 'Planning',
        resetDefaultsBtn: 'Reset to site defaults',
        profileLabel: 'Profile',
        valueLabel: 'Value',
        levelLabel: 'Level',
        harvestTarget: 'Harvest target',
        egi: 'EGI',
        efi: 'EFI',
        mortality: 'Mortality',
        feedStrategy: 'Feed strategy',
        temperature: 'Temperature',
        profileLevelCountry: 'Market',
        profileLevelSite: 'Site',
        profileLevelFishGroup: 'Fish Group',
        dialogDeleteVirtual: 'Delete virtual fish group',
        emptyLevel: 'Not defined',
      },
      profilesDialog: {
        title: 'Change {type} profile',
        byWeightLabel: 'Harvest Target',
        weightBtn: 'Weight',
        dateBtn: 'Date',
        weightLabel: 'Weight',
        dateLabel: 'Date',
        egiLabel: 'Egi',
        efiLabel: 'Efi',
        mortalityLabel: 'Mortality',
        feedStrategyLabel: 'Feed Strategy',
      },
      feedStrategyList: {
        title: 'View Feed Strategy',
        fromWeightLabel: 'From Weight',
        nameLabel: 'Product Name',
        editBtn: 'Edit Feed Strategy',
      },
      temporaryPlanningList: {
        title: 'Temporary Planning',
        noResults: 'No temporary planning found',
        editTemporaryProfiles: 'Edit Temporary Profiles & Feed Strategies',
        assignTemporary: 'Assign Temporary Profiles & Feed Strategies',
        profile: 'Profile',
        type: 'Type',
        id: 'Id',
      },
    },
    listNotifications: {
      title: 'Notifications',
      list: {
        noResults: 'No notifications found',
        startDateLabel: 'Start date',
        endDateLabel: 'End date',
        unitNameLabel: 'Cage',
        fishGroupNameLabel: 'Fish Group',
        siteNameLabel: 'Site',
        commentLabel: 'Comment',
      },
    },
    alert: {
      title: 'Calculation in progress',
      info: 'Your planning and prognosis data is being calculated, please wait a few minutes',
    },
    tabs: {
      activeSite: 'Active sites',
      harvested: 'Harvested sites',
      other: 'Other Suppliers',
      active: 'Active',
      historic: 'Historic',
    },
    feedSummary: {
      title: 'Sites Feed Summary',
      graphDate: 'Date',
      graphValue: 'Value',
      actual: 'Actual',
      planned: 'Planned',
      delivered: 'Delivered',
      forecast: 'Forecast',
    },
    siteDetails: {
      title: 'Site Feed Plan',
      showTableBTN: 'Show Table',
    },
  },
  bluViuNutrition: {
    title: 'Simulate Feed Programs',
    navigation: {
      listScenarios: 'bluViu Nutrition R1',
      listCalibrations: 'Calibrations',
      listBluViuNutritionR2: 'bluViu Nutrition R2',
      viewScenarioResult: 'Result',
      viewScenarioResultGt2: 'Result',
    },
    listScenarios: {
      title: 'Scenarios',
      createButton: 'Create Scenario',
      copy: 'Copy',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      createDialog: {
        title: 'Create scenario',
        nameLabel: 'Name',
        isLandBasedFarmingLabel: 'Model name',
      },
      cloneDialog: {
        title: 'Clone scenario',
        emptyModel: 'Outdated scenarios cannot be copied',
        nameLabel: 'Name',
      },
      list: {
        noResults: 'No scenarios found',
        modelLabel: 'Model',
        nameLabel: 'Name',
        updatedDateLabel: 'Updated',
        stateLabel: 'State',
      },
      filters: {
        state: {
          title: 'State',
        },
      },
    },
    viewScenarioResult: {
      title: 'Result for {name}',
      exportCSVBtn: 'Export to CSV',
      noScenario: 'No Scenario selected',
      tabs: {
        siteSummaryLabel: 'Site Summary',
        unitSummaryLabel: 'Unit Summary',
        lcaSummaryLabel: 'LCA Summary',
      },
      filters: {
        title: 'Show Data',
        columns: {
          permutation: 'Permutation',
          feedIntakeTons: 'Feed Intake, T',
          productionWeeks: 'Production Weeks',
          stockingBiomassTons: 'Stocking Biomass, T',
          harvestBiomassTons: 'Harvest Biomass, T',
          harvestHogBiomassTons: 'Harvest Hog Biomass, T',
          harvestCount: 'Harvest Count',
          salesIncomeMillions: 'Sales Income, M',
          feedCostMillions: 'Feed Cost, M',
          fishCostMillions: 'Fish Cost, M',
          operationsCostMillions: 'Operations Cost, M',
          harvestCostMillions: 'Harvest Cost, M',
          totalCostMillions: 'Total Cost, M',
          netProfitMillions: 'Net Profit, M',
          netProfitMillionsPerYear: 'Net Profit, M/Year',
          harvestHogBiomassTonsPerYear: 'Harvest Hog Biomass, T/Year',
          bFcr: 'bFcr',
          eFcr: 'eFcr',
          gwpTons: 'gwp, T',
          lostNTons: 'Lost N, T',
          feedProgram: 'Feed Program',
          productionUnit: 'Production Unit',
          breakPeriodWeeks: 'Break Period Weeks',
          harvestWeightGPerFish: 'Harvest Weight, g/Fish',
          harvestHogWeightGPerFish: 'Harvest Hog Weight, g/Fish',
          feedIntakeGPerFish: 'Feed Intake, g/Fish',
          filletAxMgPerKg: 'Fillet Ax, mg/kg',
          growthTons: 'Growth, T',
          fishGroupId: 'Fish Group Id',
        },
        lcaColumns: {
          fishGroupId: 'Fish Group Id',
          perm: 'Perm',
          prodDays: 'Prod Days',
          unitName: 'Unit Name',
          L132: 'Global warming - incl LUC, kg CO₂ eq',
          L131: 'Global warming - excl LUC, kg CO₂ eq',
          L133: 'Stratospheric ozone depletion, kg CFC11 eq',
          L134: 'Ionizing radiation, kBq Co-60 eq',
          L135: 'Ozone formation, Human health, kg NOx eq',
          L136: 'Fine particulate matter formation, kg PM2.5 eq',
          L137: 'Ozone formation, Terrestrial ecosystems, kg NOx eq',
          L138: 'Terrestrial acidification, kg SO2 eq',
          L139: 'Freshwater eutrophication, kg P eq',
          L140: 'Marine eutrophication, kg N eq',
          L141: 'Terrestrial ecotoxicity, kg 1,4-DCB',
          L142: 'Freshwater ecotoxicity, kg 1,4-DCB',
          L143: 'Marine ecotoxicity, kg 1,4-DCB',
          L144: 'Human carcinogenic toxicity, kg 1,4-DCB',
          L145: 'Human non-carcinogenic toxicity, kg 1,4-DCB',
          L146: 'Land use, m2a crop eq',
          L147: 'Mineral resource scarcity, kg Cu eq',
          L148: 'Fossil resource scarcity, kg oil eq',
          L149: 'Water consumption, m3',
          L150: 'Land Use Change (LUC), kg CO₂ eq',
          feedProgram: 'Feed Program',
          feedName: 'Feed Name',
          endStage: 'End Stage',
        },
      },
      label: {
        endStageSeaProductions: 'End Stage Sea Productions',
        endStageHog: 'End Stage Hog',
      },
    },
    viewScenarioResultGt2: {
      title: 'Summary Type',
      exportCSVBtn: 'Export results',
      referenceFeedProgram: 'Select Reference Feed Program',
      getResult: 'Get Results',
      noScenario: 'No Scenario selected',
      compareFeeds: 'Compare now',
      weeksRangeRequired: 'Please enter a week number between {minWeek} and {maxWeek}',
      weightsRangeRequired: 'Please enter weight in the range between {minWeight} g and {maxWeight} g ',
      adjustWeekLabel: 'Adjust weeks to range',
      adjustWeightLabel: 'Adjust weight to range',
      topPerformers: 'Top performers',
      lowestCo2Feed: 'has {percentage}% lower CO₂ emission per kg growth than the second best feed program',
      bestBiologyFeedWeek: 'resulted in {percentage}% higher weight gain after {week} weeks than the second best feed program',
      bestBiologyFeedWeight: 'reached the target weight {daysToReach} days quicker than the second best feed program',
      mostEconomicalFeed: ' resulted in {percentage}% lower average feed price than the second best feed program',
      selectedFeeds: 'You have {quantity} feed programs selected',
      productionRangeMessage: 'Scenario is outside of the intended scenario production range',
      clear: 'Clear',
      fixedNumber: 'less than 0.1',
      icons: {
        lowestCo2Title: 'Lowest CO₂',
        bestBioTitle: 'Fastest growth',
        mostEconomicalTitle: 'Lowest feed price',
        bestBFcrTitle: 'Best bFCR',
        lowestCostOfGrowthTitle: 'Lowest cost of growth',
      },
      compareDialog: {
        compareDialogTitle: 'Compare feed programs',
        table: 'Table',
        graph: 'Graph',
      },
      kpis: {
        selectAll: 'Select all',
        labels: {
          finalWeightGrams: 'Final Weight',
          weightGainGrams: 'Weight Gain',
          hogGainGrams: 'HOG Gain',
          daysToReach: 'Days to harvest',
          feedIntakeGrams: 'Feed intake',
          bFcr: 'bFCR',
          eFcr: 'eFCR',
          carcassYieldPercent: 'Carcass yield (%)',
          filletFatPercent: 'Fillet fat (%)',
          averageFeedCostPerKgFeed: 'Average Feed Cost',
          feedCostOfGrowth: 'Feed cost of growth',
          feedCostOfHogGain: 'Feed Cost of HOG Growth',
          feedCostTotal: 'Total feed cost',
          operationsCostTotal: 'Total operation cost',
          smoltCostTotal: 'Total smolt cost for all',
          harvestCostTotal: 'Total harvest cost',
          treatmentCostTotal: 'Total sealice cost',
          totalCost: 'Total Cost',
          potentialSalesValue: 'Potential Sales Value',
          potentialProfit: 'Potential Profit',
          globalWarmingPotentialCo2KgPerKgFeed: 'GWP CO₂/kg feed',
          globalWarmingPotentialCo2KgPerKgGrowth: 'GWP CO₂/kg growth',
        },
        tooltips: {
          finalWeightGrams: 'Average fish weight at the end of the scenario. Formula: start weight + weight gain',
          weightGainGrams: 'Average weight gain per fish. Formula: final weight - start weight',
          hogGainGrams:
            'Average HOG growth per fish, calculated as the sellable head-on-gutted share of fish weight gain. Formula: HOG growth = weight gain × carcass yield',
          daysToReach: 'Number of days from scenario start until the final weight point is reached',
          feedIntakeGrams: 'Average feed consumed per fish during the scenario period',
          bFcr: 'Biological feed conversion ratio. Feed required to produce 1 kg of weight gain. Formula: feed intake ÷ weight gain ',
          eFcr: 'Economic feed conversion ratio. Feed consumed per kg of biomass produced, including production losses ',
          carcassYieldPercent: 'Expected harvest yield at slaughter. Formula: HOG weight ÷ live weight × 100 ',
          filletFatPercent: 'Predicted fillet fat content at slaughter',
          averageFeedCostPerKgFeed:
            'Weighted average feed cost of the feed programme based on the expected feed consumption of each feed. Formula: total feed cost ÷ total feed consumed ',
          feedCostOfGrowth:
            'Weighted average feed cost required to produce 1 kg of live weight gain. Formula: total feed cost ÷ total weight gain',
          feedCostOfHogGain:
            'Weighted average feed cost required to produce 1 kg of HOG growth. Formula: total feed cost ÷ total HOG growth',
          feedCostTotal: 'Total cost of all feed consumed during the scenario',
          operationsCostTotal: 'Total operational costs based on production duration and the operational cost per week ',
          smoltCostTotal: 'Total smolt costs based on the number of stocked smolts and the smolt cost per smolt',
          harvestCostTotal: 'Total harvest costs based on harvest biomass and the harvest cost per kg',
          treatmentCostTotal: 'Total sealice treatment costs based on the number of treatments and the cost per treatment',
          totalCost:
            'Total production cost including feed cost and other production costs (treatments, fixed costs, variable costs, etc.)',
          potentialSalesValue:
            'Estimated sales value of harvested HOG biomass. Formula: total HOG biomass × relevant sales price per kg HOG ',
          potentialProfit: 'Estimated profit after production costs. Formula: Potential Sales Value - Total Production Cost',
          globalWarmingPotentialCo2KgPerKgFeed:
            'Weighted average CO₂e footprint per kg feed for the feed programme, calculated from the iLUC value of each feed and the expected feed consumption across the programme ',
          globalWarmingPotentialCo2KgPerKgGrowth:
            'Total predicted CO₂e impact per kg of fish growth from feed use. Formula: total feed consumed × feed GWP ÷ total fish growth ',
        },
      },
      tooltip: {
        weightGainGrams: 'Predicted final weight of the fish minus stocking weight',
        feedIntakeGrams: 'Predicted total feed consumption',
        filletFatPercent: 'Predicted % of fat in the fillet',
        feedCostOfGrowth:
          'Predicted final weight gain multiplied by % carcass yield. Example: 4000g weight gain x 88% carcass yield = 3520g HOG gain',
        carcassYieldPercent: 'Predicted % of fish that becomes HOG (Head-on-gutted). Fish weight – guts, visceral fat',
        finalWeightGrams: 'Model predicts the final weight of the fish',
        bFcr: 'Predicted total feed intake / weight gain',
        averageFeedCost:
          'For each feed program: The price of each feed multiplied by the amount of feed supplied, added together, and divided by the total amount of feed supplied',
        feedCostOfHogGrowth:
          'Total predicted feed cost / (weight gain x carcass yield).  Example:75kr total feed cost / 4000g weight gain x 88% carcass yield = 21.30 NOK',
        globalWarmingPotentialCo2KgPerKgGrowth: 'Total global warming potential (I_LUC) x predicted feed consumed / kg weight gain',
        hogGainGrams:
          'Predicted final weight gain multiplied by % carcass yield. Example: 4000g weight gain x 88% carcass yield = 3520g HOG gain',
        tooltipContent: 'Feed program',
        feedsInProgram: 'Feeds in program: ',
      },
      compareTable: {
        finalWeightGrams: 'Final Weight',
        daysToReach: 'Days To Reach',
        weightGainGrams: 'Weight Gain',
        feedIntakeGrams: 'Feed Intake',
        bFcr: 'bFCR',
        carcassYieldPercent: 'Carcass Yield (%)',
        filletFatPercent: 'Fillet Fat (%)',
        hogGainGrams: 'HOG Gain (g)',
        globalWarming: 'GWP CO₂/kg growth',
        averageFeedCost: 'Average Feed Cost',
        feedCostOfGrowth: 'Feed Cost Of Growth',
        feedCostOfHogGrowth: 'Feed Cost Of HOG Growth',
        reference: 'Reference',
      },
      filters: {
        types: {
          week: 'Week',
          weight: 'Weight',
        },
        visibleKpis: 'Visible KPIs',
        week: 'Week',
        weekLabel: 'Enter {minWeek} - {maxWeek} weeks',
        weight: 'Target Weight',
        weightLabel: 'Enter {minWeight} - {maxWeight} g',
      },
      columns: {
        feedPlan: 'Feed Program',
        feedPlanMaxWeeks: 'Feed Plan Max Weeks',
        feedPlanMaxWeight: 'Feed Plan Max Weight',
        finalWeightGrams: 'Final Weight(g)',
        daysToReach: 'Days To Reach',
        weightGainGrams: 'Weight Gain(g)',
        feedIntakeGrams: 'Feed Intake(g)',
        bFcr: 'bFCR',
        carcassYieldPercent: 'Carcass Yield(%)',
        filletFatPercent: 'Fillet Fat(%)',
        hogGainGrams: 'HOG Gain(g)',
        globalWarmingPotentialCo2KgPerKgGrowth: 'GWP CO₂/kg growth',
        globalWarmingPotentialCo2KgPerKgFeed: 'GWP CO₂/kg feed',
        averageFeedCost: 'Avg. Feed Cost',
        feedCostOfGrowth: 'Avg. Cost Of Growth',
        feedCostOfHogGrowth: 'Cost Of HOG Gain',
      },
      tabs: {
        compare: 'Compare',
        result: 'Results',
        graph: 'Graph',
      },
      graph: {
        yWeight: 'Weight',
        xWeek: 'Week',
        productionWeek: 'Production Week',
      },
    },
    setUp: {
      title: 'Setup a site',
      viewResultsBTN: 'View Result',
      submit: 'Submit Scenario',
      save: 'Save',
      label: {
        name: {
          title: 'Scenario name',
          modelName: 'Scenario model',
          placeholder: 'Add scenario name',
        },
        site: 'Select Site',
        calibration: 'Calibration',
        description: {
          title: 'Scenario description',
          placeholder: 'Add scenario description',
        },
      },
      warningText: {
        calibration: 'Site is not calibrated.',
        modelType: 'Site has incorrect model.',
        range: 'Start weight has to be between 50 and 3000',
      },
      settingsRun: {
        title: 'Scenario settings and run',
        startDate: 'Start Date',
        endDate: 'End Date',
        fishWeight: 'Start Weight',
        startDateError: 'Start Date is not before End Date',
        endDateError: 'End Date is not after Start Date',
      },
    },
    availableFeeds: {
      title: 'Available feeds',
      save: 'Save',
      label: {
        feedProgram: 'Feed program',
        fishSize: 'Fish size',
        feed: 'Feed',
        feedSource: 'Feed source',
        feedAx: 'Feed ax, mg/kg',
        feedMaizeGluten: 'Feed maize gluten(%)',
        relativeMortalityImpact: 'Relative mortality impact',
        relativeGrowthImpact: 'Relative growth impact',
        salmonPricePremium: 'Price premium /kg gutted',
        formulationCost: 'Formulation cost /ton',
        customerPrice: 'Customer price',
      },
    },
    availableFeedsEEGt2P: {
      title: 'Scenario feed programs',
      select: {
        currency: 'Currency',
        NOK: 'NOK/100kg',
        USD: 'USD/ton',
      },
    },
    settingsRun: {
      title: 'Scenario settings',
      addCustomBtn: 'Add Custom Unit',
      label: {
        selectProductionUnit: 'Select Production Unit',
        currency: 'Currency',
        unit: 'Unit',
        fishWeight: 'Fish weight, g',
        fishCount: 'Fish count',
        statDate: 'Start date',
        fishCost: 'Fish cost (per kg stocked)',
        dailyCost: 'Daily cost (per day)',
        harvestCost: 'Harvest cost (per kg HOG)',
        simulationFor: 'Simulation for',
        targetWeight: 'Target weight (g)',
        productionWeeks: 'Production Weeks',
        breakPeriod: 'Break period before restocking (weeks)',
        salmonPrice: 'Salmon price {currency}',
        fishpoolPrice: 'Fishpool price {currency}',
        enterManually: 'Enter manually',
        selectionCriteria: 'Selection criteria',
        feedConversionBiological: 'Feed Conversion Biological',
        feedCostPerSite: 'Feed Cost/Site',
        harvestHogPerSitePerYear: 'Harvest Hog/Site/Year',
        netProfitPerSite: 'Net Profit/Site',
        netProfitPerSitePerYear: 'Net Profit/Site Per Year',
        productionTime: 'Production Time',
        salesIncomePerSite: 'Sales Income/Site',
        totalCostPerSite: 'Total Cost/Site',
        setRegulatoryFramework: 'Set regulatory framework',
        noLimits: 'No limits',
        maximumAllowedBiomass: 'Maximum allowed biomass',
        harvestMethod: 'Harvest method',
        batchHarvest: 'Batch Harvest',
        allowedBiomass: 'Allowed biomass limit (tons)',
      },
    },
    calibrations: {
      listCalibrations: {
        stateTooltip: {
          modified:
            'The inputs of this calibration have been modified since last calibrated. Coefficients will likely change if you run calibration again.',
        },
        list: {
          name: 'Name',
          model: 'Model',
          calibratedAt: 'Calibrated at',
          growth: 'Growth',
          feedIntake: 'Feed intake',
          state: 'State',
        },
      },
      createCalibration: {
        create: 'Create calibration',
      },
      cloneCalibration: {},
      editCalibration: {
        calibrationInProgress: {
          title: 'Calibration in progress',
          text: 'You are free to leave this page while the calibration is running. This may take a few minutes depending on the complexity of your site data.',
        },
        calibrationStatistics: {
          status: {
            title: 'Status',
            modifiedTooltip:
              'The inputs of this calibration have been modified since last calibrated. Coefficients will likely change if you run calibration again.',
          },
          weightGain: {
            title: 'Weight gain',
          },
          feedIntake: {
            title: 'Feed intake',
          },
        },
        calibrationActions: {
          exportScript: 'Export Script',
          exportCSV: 'Export CSV',
          clone: 'Clone',
        },
        calibrationInformation: {
          title: 'Calibration',
          form: {
            name: 'Calibration name',
            model: 'Calibration model',
            description: 'Calibration description',
          },
        },
        temperatureLocation: {
          temperatureProfile: {
            title: 'View Temperature Profile',
            dialogButton: 'View Temperature Profile',
            buttonGroup: {
              graph: 'Graph',
              list: 'List',
            },
            header: 'Average Temperature',
            chart: {
              week: 'Week',
              degrees: 'Degrees',
            },
            table: {
              week: 'Week',
              temperature: 'Temperature',
            },
            information: 'To edit your temperature profile, go to site settings.',
          },
          location: {
            title: 'Longitude and latitude',
            dialogButton: 'View Location',
            latitude: 'Latitude',
            longitude: 'Longitude',
            information: 'To edit your location, go to site settings.',
          },
          information: 'No temperature profile available, create one in site settings.',
        },
        inputs: {
          title: 'Inputs',
          single: {
            form: {
              stockingDate: 'Stocking date',
              stockingFishWeight: 'Stocking fish weight',
              harvestDate: 'Harvest date',
              harvestFishWeight: 'Harvest fish weight',
              harvestCyclebFcr: 'Harvest Cycle bFCR',
            },
          },
          multi: {
            selectYear: 'Select year',
            information: 'Select year that you want to use as inputs for calibration.',
            cages: {
              information: 'Select cages that you want to use as inputs for calibration.',
              list: {
                fishGroup: 'Fish group',
                cageTooltip: 'Cage: {unitName}',
                stockingDate: 'Stocking date',
                startWeight: 'Start weight',
                bFCR: 'bFCR',
                harvestDate: 'Harvest date',
                avgHarvestMW: 'Avg. Harvest MW',
                egi: 'EGI',
              },
            },
          },
        },
        feedProgram: {
          title: 'Feed program',
          columns: {
            feed: 'Feed',
            quantity: 'Fish start size (g)',
          },
        },
        runCalibration: {
          information: 'Running the calibration may take a while depending on the complexity of your site data.',
          button: 'Run calibration',
        },
      },
    },
    applyFeed: {
      title: 'Áp dụng chương trình thức ăn',
      stepIndicator: 'Bước {step} của {total} - {stepLabel}',
      buttonLabel: 'Áp dụng chương trình thức ăn',
      confirmAndApply: 'Xác nhận và áp dụng',
      missingMapping: 'Một số sản phẩm chưa được ánh xạ',
      applyAs: {
        label: 'Áp dụng như:',
        plan: {
          title: 'Kế hoạch',
          description: 'Kế hoạch thực tế mà trang trại sẽ tuân theo.',
        },
        forecast: {
          title: 'Dự báo',
          description: 'Kịch bản "Nếu như" để sử dụng trong chu kỳ sản xuất.',
        },
        planAndForecast: {
          title: 'Kế hoạch và Dự báo',
          description: 'Áp dụng kịch bản như cả kế hoạch và dự báo.',
        },
      },
      reviewList: {
        title: 'Xem xét chương trình thức ăn trước khi áp dụng cho trang trại:',
        fishGroup: 'Nhóm cá',
        newFeedProgram: 'Chương trình thức ăn mới',
      },
      excludedFishGroups: {
        title: 'Nhóm cá bị loại trừ',
      },
      mapping: {
        infoBox:
          'Sản phẩm trong bluViu Nutrition không giống với SAP. Ánh xạ sản phẩm trong chương trình thức ăn để bluViu Nutrition và OFD có thể kết nối.',
        weight: 'Trọng lượng',
        feedsInBluViuNutrition: 'Thức ăn trong bluViu Nutrition',
        feedsInSAP: 'Thức ăn trong SAP',
        product: 'Sản phẩm *',
        mappedLabel: 'đã ánh xạ',
      },
    },
  },
  bluViuNutritionR2: {
    scenarioValidation: {
      invalidFishGroupData: 'One or more fish groups contain invalid data.',
      reviewFishGroupData: 'Please review the imported fish-group data.',
      reviewScenarioEndDate: 'Please review the Scenario end date in the Production Inputs section below.',
    },
    results: {
      graph: {
        allAvgForSite: 'All (Avg. for site)',
        allPrograms: 'All Programs',
        potentialSalesValue: 'Potential Sales Value',
        potentialSalesValueDisabled: 'Select one feed program to view potential sales value.',
        showFeedProgram: 'Show feed program',
        showResultsFor: 'Show results for',
        valueBySizeClass: 'Total value by size class',
        valueBySizeClassDisabled: 'Select one feed program to view value by size class.',
        weeks: 'Weeks',
        weight: 'Weight (g)',
      },
    },
  },
  fishCheck: {
    navigation: {
      listWelfareScoring: 'Welfare Scoring',
      dialog: {
        deleteTitle: 'Delete Sample',
        title: 'Start',
        templateAndSiteLabel: 'Select site and template',
        templateLabel: 'Select template',
        nameLabel: 'Enter Name',
        siteLabel: 'Select Site',
      },
    },
    header: {
      siteNameLabel: 'Site',
      dateCreatedLabel: 'Created',
      dateLastUpdatedLabel: 'Date Last Updated',
      activeLabel: 'Active',
      commentLabel: 'Comment',
      addNewFishLabel: 'Add new fish',
    },
    listWelfareScoring: {
      title: 'Welfare Scoring Reports',
      list: {
        noResults: 'No Results',
        nameLabel: 'Name',
        siteNameLabel: 'Site',
        dateCreatedLabel: 'Created',
        activeLabel: 'Active',
      },
    },
    editWelfareScoring: {
      title: 'Edit {name}',
      editTitle: 'Edit Sample',
      updateSample: 'Update sample',
      alert: 'One or more fields must have a value',
      fishGroupIdLabel: 'Select Production Unit',
      dateCreatedLabel: 'Select Date',
      fishWelfareData: {
        cageLabel: 'Cage',
        fishGroupLabel: 'Fish Group',
        adultFemaleLice: 'Adult Female Lice',
        kFactor: 'K-Factor',
        skinBleeding: 'Skin Bleeding',
        wounds: 'Wounds',
        length: 'Length',
        weight: 'Weight',
        stationaryLice: 'Stationary Lice',
        mobileLice: 'Mobile Lice',
        scottishLice: 'Scottish Lice',
        backboneDeformity: 'Backbone Deformity',
        thinness: 'Thinness',
        maturation: 'Maturation',
        scaleLoss: 'Scale Loss',
        snoutWounds: 'Snout Wounds',
        jawDeformity: 'Jaw Deformity',
        paleEye: 'Pale Eye',
        eyeDamage: 'Eye Damage',
        gillCover: 'Gill Cover',
        gillStatus: 'Gill Status',
        finStatus: 'Fin Status',
        firstImpression: 'First Impression',
        comment: 'Comment',
      },
    },
  },
  feedManagement: {
    navigation: {
      listPlants: 'Plants',
      listNutrients: 'Nutrients',
      listBestMixFeeds: 'BestMix Feeds',
      listManualFeeds: 'Manual Feeds',
      listCustomers: 'Customers',
    },
    listPlants: {
      title: 'Plants',
      button: 'Create plants',
      list: {
        noResults: 'You have no plants',
        codeLabel: 'Code',
        nameLabel: 'Name',
        marketsLabel: 'Markets',
      },
      dialog: {
        title: 'Create new Plant',
        codeLabel: 'Code',
        marketsLabel: 'Market',
        nameLabel: 'Name',
      },
      tooltip: {
        product: 'Products does not have base nutrient values to support nutrient calculation',
        incorrectValues: 'BestMix nutrients updated by BluViu',
      },
    },
    listNutrients: {
      title: 'Select Nutrients',
      digestibleFatGPerKgLabel: 'Digestible Fat',
      feedGwpKgCo2EqPerKgLabel: 'Feed Gwp',
      idealProteinNitrogenLabel: 'Ideal Protein Nitrogen',
      nonIdealProteinNitrogenLabel: 'Non-ideal Protein Nitrogen',
    },
    editPlant: {
      title: '{code} {name}',
      list: {
        title: 'Linked Markets',
        noResults: 'No Results',
        nameLabel: 'Market',
        actionLabel: 'Remove',
      },
      selectMarketLabel: 'Select Market',
    },
    listBestMixFeeds: {
      title: 'Products',
      deactivateFeeds: 'Deactivate Feeds',
      activateFeeds: 'Activate Feeds',
      selectAllFeeds: 'Select all feeds on current page',
      linkToCustomer: 'link to Customer',
      list: {
        noResults: 'No Results',
        nameLabel: 'Name',
        numberLabel: 'Code / Number',
        updatedDateLabel: 'Updated Date',
        activeLabel: 'Show active',
        inactiveLabel: 'Show inactive',
      },
      filter: {
        plantLabel: 'Plant',
        statusLabel: 'Options',
        options: {
          active: 'Active',
          temporary: 'Temporary',
          hasMandatoryNutrients: 'Invalid',
        },
      },
      dialog: {
        deactivate: 'Deactivate',
        activate: 'Activate',
        activateTitle: 'Activate Feeds',
        deactivateTitle: 'Deactivate Feeds',
        activateDialog: 'Are you sure you want to activate the selected feeds?',
        deactivateDialog: 'Are you sure you want to deactivate the selected feeds?',
        linkToSelectedCustomers: 'Link selected products?',
        customerSelect: 'Customers',
      },
      tooltip: {
        product: 'Product does not have base nutrient values to support nutrient calculation',
        incorrectValues: 'BestMix nutrients updated by BluViu',
      },
    },
    editBestMixFeed: {
      title: '{code} {name}',
      bestMixFeedDetails: {
        title: 'Product Details',
        descriptionLabel: 'Description',
        plantCodeLabel: 'Plant Code',
        codeLabel: 'Code',
        bestMixFeedNumberLabel: 'Number',
        formulationCostLabel: 'Formulation Cost',
        bestMixFeedVersionLabel: 'Version',
      },
      assignedCompaniesList: {
        title: 'Linked Customers',
        noResults: 'No results',
        nameLabel: 'Name',
        priceLabel: 'Customer Price',
      },
      assignedCompaniesDialog: {
        openBtn: 'Link Customer',
        title: 'Link Customer',
        customerLabel: 'Customer',
        customerPricePerToneLabel: 'Customer Price/Ton',
      },
      customFieldsList: {
        title: 'Custom Fields',
        noResults: 'No results',
        nameLabel: 'Name',
        valueLabel: 'Value',
      },
      customFieldsDialog: {
        openBtn: '{action} Custom Field',
        title: '{action} Custom Field',
        customFieldsLabel: 'Custom Fields',
        customFieldValueLabel: 'Value',
      },
      nutrientsMaterialsList: {
        nutrientsTitle: 'Nutrients',
        materialsTitle: 'Materials',
        noResults: 'No results',
        codeLabel: 'Code',
        nameLabel: 'Name',
        valueLabel: 'Value',
      },
    },
    listCustomers: {
      title: 'Customers',
      list: {
        noResults: 'There is no customers',
        nameLabel: 'Customer Name',
      },
    },
    editCustomer: {
      title: '{name}',
      unlinkBtn: 'Unlink',
      disconnectBtn: 'Disconnect feeds',
      selectAllFeeds: 'Select all feeds on current page',
      linkProductDialog: {
        openBtn: 'Link New BestMix Feed',
        title: 'Link BestMix Feed',
        productsLabel: 'BestMix Feeds',
        customerPricePerToneLabel: 'Customer Price/Ton',
      },
      disconnectDialog: {
        title: 'Disconnect feeds',
        disconnectLabel: 'Disconnect selected feeds?',
        disconnectBtn: 'Disconnect',
      },
      list: {
        title: 'Linked BestMix Feeds',
        noResults: 'No linked BestMix Feeds',
        descriptionLabel: 'Linked BestMix Feeds',
        customerPricePerTonLabel: 'Customer price per ton',
        hasMandatoryNutrientsLabel: 'Missing nutrients',
        hasIncorrectBestMixNutrientValuesLabel: 'Incorrect nutrient values',
        updatedDateLabel: 'Updated Date',
      },
    },
    listManualFeeds: {
      title: 'Manual Feeds',
      deactivateFeeds: 'Deactivate Feeds',
      activateFeeds: 'Activate Feeds',
      selectAllFeeds: 'Select all feeds on current page',
      linkToCustomer: 'Link to Customer',
      createFeed: 'New Feed',
      dialog: {
        title: 'Create Manual Feed',
        nameLabel: 'Name',
        pelletSizeLabel: 'Pellet size',
        deactivate: 'Deactivate',
        activate: 'Activate',
        activateTitle: 'Activate Feeds',
        deactivateTitle: 'Deactivate Feeds',
        activateDialog: 'Are you sure you want to activate the selected feeds?',
        deactivateDialog: 'Are you sure you want to deactivate the selected feeds?',
        linkToSelectedCustomers: 'Link selected products?',
        customerSelect: 'Customers',
      },
      list: {
        noResults: 'No feeds found',
        nameLabel: 'Name',
        createdDateLabel: 'Created date',
        updatedDateLabel: 'Updated date',
        activeLabel: 'Active',
        inactiveLabel: 'Inactive',
        feedFilterLabel: 'Filters',
        feedFilterOptions: {
          all: 'All',
          currentCompany: 'Current Company',
          me: 'Me',
          currentCompanyAndMe: 'Current Company and Me',
        },
      },
    },
    editManualFeed: {
      title: 'Edit a Manual feed',
      nameLabel: 'Name',
      activeLabel: 'Active',
      inactiveLabel: 'Inactive',
      list: {
        essentialNLabel: 'Essential N',
        effectiveEnergyLabel: 'Effective Energy',
        nonEssentialNLabel: 'Non Essential N',
        crudeProteinLabel: 'Crude Protein',
        feedGwpLabel: 'Feed GWP',
        digestibleFatLabel: 'Digestible Fat',
        idealProteinNitrogenLabel: 'Ideal Protein Nitrogen',
        nonIdealProteinNitrogenLabel: 'Non-ideal Protein Nitrogen',
        scalingFactorFeedIntake: 'Scaling Factor Feed Intake',
        scalingFactorWeightGain: 'Scaling Factor Weight Gain',
      },
      customers: 'Customers',
      users: 'Users',
      calculateNutrients: {
        title: 'Calculate nutrients',
        calculate: 'Calculate',
        list: {
          arginine: 'Digestible Arginine salmonids',
          histidine: 'Digestible Histidine salmonids',
          isoleucine: 'Digestible Isoleucine salmonids',
          leucine: 'Digestible Leucine salmonids',
          lysine: 'Digestible Lysine salmonids',
          methionine: 'Digestible Methionine salmonids',
          phenylalanineTyrosine: 'Digestible Phenylalanine + Tyrosine salmonids',
          threonine: 'Digestible Threonine salmonids',
          tryptophan: 'Digestible Tryptophan salmonids',
          valine: 'Digestible Valine salmonids',
          methionineCysteine: 'Digestible Methionine + Cysteine salmonids',
          protein: 'Digestible Protein salmonids',
        },
      },
    },
  },
  powerBi: {
    navigation: {
      listReports: 'Reports',
    },
    listReports: {
      title: 'Reports',
      list: {
        noResults: 'No Results',
        nameLabel: 'Name',
      },
    },
    viewReport: {
      utils: {
        downloadBtn: 'Download PDF',
        exportBtn: 'Export PDF',
        fullscreenBtn: 'Fullscreen',
      },
      error: {
        message: 'The Report you are trying to access cannot be found at the moment',
        title: 'Reports',
      },
    },
  },
  fileSharing: {
    title: 'File Sharing',
    currentFolder: 'Current Folder',
    subFolders: 'Subfolders',
    files: 'Files',
    selectFromList: 'Select file from the list',
    list: {
      name: 'Name',
      dateCreated: 'Date Created',
      folderName: 'Folder Name',
      noSubFolders: 'No subfolders found',
    },
  },
  seaCloudFileUpload: {
    cancelButton: 'Cancel and discard file',
    navigation: {
      viewFileSummary: 'File upload',
    },
    viewFileSummary: {
      title: 'Send farm data to SeaCloud',
    },
  },
  shrimpDataUpload: {
    navigation: {
      viewShrimpDataUpload: 'File upload',
    },
    fileTypeError: 'Unsupported file type. Please upload an Excel (.xlsx or .xls) file.',
    uploadSuccess:
      'File successfully uploaded! Processing the file can take some time, you will get a detailed report via email once it is done.',
    uploadButton: 'Upload file',
    chooseProductionFile: 'Choose a PRODUCTION data file for upload',
    chooseSanitationFile: 'Choose a SANITARY data file for upload',
    chooseFile: 'Choose file',
  },
  productionSystems: {
    lockPondContainer: {
      partialLock: {
        bold: 'Một số ao hiện đang bị khóa bởi người dùng khác.',
        message: 'Các ao này sẽ không hiển thị trong tài khoản đăng ký của bạn.',
      },
      fullLock: {
        bold: 'Ao bạn chọn hiện đang bị khóa bởi người dùng khác.',
        message: 'Chọn ao khác hoặc tiếp tục với chế độ "chỉ xem".',
      },
      notGrantedLabel: 'Ao bị khóa bởi người dùng khác (không được hiển thị)',
      grantedLabel: 'Ao đích đến',
    },
    listSelectedPonds: {
      registrationDate: 'Ngày đăng ký',
      selectedPonds: 'Ao đã chọn',
      list: {
        name: 'Tên',
        zone: 'Vùng',
        status: 'Tình trạng',
        activeDays: 'Ngày hoạt động',
      },
    },
    summary: 'Tóm tắt',
    selectFarm: 'Chọn Farm',
    pondName: 'Tên Ao',
    timer: {
      reset: 'Thiết lập lại',
      error: 'Phiên làm việc của bạn đã hết hạn do không hoạt động. Các thay đổi chưa được lưu',
      expire: 'Phiên làm việc này sẽ hết hạn trong {time}',
    },
    selectedFarm: 'Farm đã chọn: ',
    selectedDate: 'Ngày đăng ký đã chọn: ',
    farmOverview: {
      title: 'Tổng quan Farm',
      farms: {
        name: 'Farm',
        numberOfPonds: 'Số lượng ao',
        lastRegistrationDate: 'Ngày đăng ký gần nhất',
      },
      duplicateRegistration: 'This event is already registered on {date} for: {ponds}. Please check to avoid entering a duplicate.',
      list: {
        name: 'Tên',
        zone: 'Vùng',
        active: 'Tích cực',
        days: 'Số lượng ngày',
        noShrimps: 'Số lượng tôm',
        biomass: 'Sản lượng ({type})',
        meanWeight: 'Cân nặng trung bình (g)',
      },
      buttons: {
        newStock: 'Thêm đàn mới',
        newTransfer: 'Thêm lần san ao',
        newHarvest: 'Thêm lần thu hoạch',
        newFeeding: 'Thêm loại thức ăn',
        sampling: 'Thêm cân nặng trung bình mẫu',
        waterQuality: 'Chất lượng nước',
        newTreatment: 'Thêm cách xử lý',
        previousDay: 'Ngày trước',
        nextDay: 'Ngày sau',
      },
      filters: {
        showActive: 'Hiển thị ao đang hoạt động',
        showInactive: 'Hiển thị ao không hoạt động',
        registrationDate: 'Ngày đăng ký',
        zone: 'Bộ lọc',
        selectAll: 'Chọn tất cả',
        pondType: 'Loại ao',
        poundsOrKg: 'Pounds (lbs) / kg',
        pondTypes: {
          Production: 'Thương phẩm',
          Raceway: 'Raceway',
          Nursery: 'Ương',
        },
      },
      feeding: {
        add: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số hiện tại',
          meanWeight: 'Cân nặng trung bình hiện tại (g)',
          biomass: 'Sản lượng hiện tại ({type})',
          feed: 'Thức ăn',
          feederBrand: 'Tra cứu Feeder',
          feedQuantity: 'Lượng thức ăn ({type})',
          summary: 'Tóm tắt',
          switchLabel: 'Pounds (lbs) / Kg',
        },
        edit: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng tôm',
          meanWeight: 'Cân nặng trung bình (g)',
          biomass: 'Sản lượng ({type})',
          feed: 'Thức ăn',
          feederBrand: 'Tra cứu Feeder',
          feedQuantity: 'Lượng thức ăn ({type})',
          summary: 'Tổng kết',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      stocking: {
        deliveredTrackingCode: 'Mã theo dõi đơn giao',
        genetics: 'Giống',
        larvaCost: 'Giá PL/1000',
        maturation: 'Nguồn tôm bố mẹ',
        nauplius: 'Trại giống',
        laboratoryPl: 'Laboratory PL',
        grid: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          startMeanWeight: 'Khối lượng trung bình ban đầu (g)',
          targetMeanWeight: 'Khối lượng trung bình mục tiêu (g)',
          startQuantity: 'Số lượng ban đầu',
          biomass: 'Sản lượng (kg)',
          targetQuantity: 'Số lượng mục tiêu',
          targetEndDate: 'Tổng ngày nuôi (Days)',
          survivalRate: 'Tỉ lệ sống',
          summary: 'Tóm tắt',
        },
      },
      harvest: {
        processorReference: 'Processor reference',
        add: {
          harvestPond: 'Ao thu hoạch',
          number: 'Số lượng hiện tại',
          meanWeight: 'Cân nặng trung bình hiện tại (g)',
          biomass: 'Sản lượng hiện tại {type}',
          harvestNumber: 'Số lượng thu hoạch ',
          harvestMw: 'Cân nặng trung bình thu hoạch (g)',
          harvestBm: 'Sản lượng thu hoạch {type}',
          partialHarvest: 'Thu tỉa',
          remainingNumber: 'Số lượng chưa thu',
          remainingMw: 'Cân nặng trung bình chưa thu (g)',
          remainingBm: 'Sản lượng chưa thu {type}',
          summary: 'Tóm tắt',
          switchLabel: 'Pounds (lbs) / Kg',
        },
        edit: {
          harvestPond: 'Ao thu hoạch',
          number: 'Số lượng tôm',
          meanWeight: 'Cân nặng trung bình (g)',
          biomass: 'Sản lượng {type}',
          harvestNumber: 'Số lượng thu hoạch ',
          harvestMw: 'Cân nặng trung bình thu hoạch (g)',
          harvestBm: 'Sản lượng thu hoạch {type}',
          partialHarvest: 'Thu tỉa',
          remainingNumber: 'Số lượng chưa thu',
          remainingMw: 'Cân nặng trung bình chưa thu (g)',
          remainingBm: 'Sản lượng chưa thu {type}',
          summary: 'Tóm tắt',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      sampling: {
        add: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng tôm',
          meanWeight: 'Cân nặng trung bình hiện tại (g)',
          biomass: 'Sản lượng hiện tại {type}',
          newMeanWeight: 'Cân nặng trung bình mới (g)',
          survivalRate: 'Tỉ lệ sống',
          summary: 'Tóm tắt',
        },
        edit: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng tôm',
          meanWeight: 'Cân nặng trung bình (g)',
          biomass: 'Sản lượng {type}',
          newMeanWeight: 'Cân nặng trung bình mới (g)',
          survivalRate: 'Tỉ lệ sống',
          summary: 'Tóm tắt',
        },
      },
      transfer: {
        title: 'San ao',
        sourcePond: 'Ao ban đầu',
        destinationPonds: 'Ao đích đến',
        confirmTransfer: 'Xác nhận',
        partialTransferError: 'Ao ban đầu phải được san hoàn toàn. Bạn có thể chọn san tỉa một phần ở phía trên.',
        errorMessage: 'Dữ liệu phải lớn hơn 0',
        transferNumberError: 'Số lượng san tỉa phải thấp hơn số lượng hiện tại',
        selectDestinationPond: 'Chọn ao đích đến',
        fields: {
          selectedDate: 'Ngày đăng ký đã chọn',
          sourcePond: 'Ao ban đầu',
          cycleName: 'Tên chu kỳ nuôi',
          destinationPond: 'Ao đích đến',
          referenceCode: 'Delivered reference code',
          partialTransfer: 'San tỉa',
        },
        list: {
          name: 'Tên',
          zone: 'Vùng',
          status: 'Tình trạng',
          noShrimps: 'Số lượng tôm',
          biomass: 'Sản lượng (kg)',
          meanWeight: 'Cân nặng trung bình (g)',
          days: 'Số ngày',
        },
        listHeaders: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          meanWeight: 'Cân nặng trung bình (g)',
          biomass: 'Sản lượng {type}',
          harvestDate: 'Ngày thu hoạch',
          survivalRate: 'Tỉ lệ sống',
        },
        add: {
          source: {
            sourcePond: 'Ao ban đầu',
            cycleName: 'Tên chu kỳ nuôi',
            currentNumberAdd: 'Số lượng hiện tại (before transfer)',
            currentMw: 'Cân nặng trung bình hiện tại (g)',
            currentBm: 'Sản lượng hiện tại (kg)',
            newCycleName: 'Tên vụ nuôi mới',
            transferNumber: 'Số lượng san',
            remainingQty: 'Số lượng còn lại',
            remainingMw: 'Cân nặng trung bình còn lại (g)',
            remainingBm: 'Sản lượng còn lại (kg)',
          },
          destination: {
            destinationPond: 'Ao đích đến',
            currentQty: 'Số lượng hiện tại (trước khi san)',
            cycleName: 'Tên chu kỳ nuôi',
            transferQty: 'Số lượng san',
            transferMw: 'Cân nặng trung bình (g)',
            transferBm: 'Sản lượng (kg)',
            summary: 'Tóm tắt',
          },
        },
        edit: {
          source: {
            sourcePond: 'Ao ban đầu',
            partialTransfer: 'Chuyển nhượng một phần',
            fullTransfer: 'Chuyển khoản đầy đủ',
            cycleName: 'Tên chu kỳ nuôi',
            currentQty: 'Số lượng tôm (trước khi san)',
            currentMw: 'Cân nặng trung bình (g) (trước khi san)',
            currentBm: 'Sản lượng (kg) (trước khi san)',
            newCycleName: 'Tên chu kỳ nuôi',
            transferNumber: 'Số lượng san',
            remainingQty: 'Số còn lại',
            remainingMw: 'Cân nặng trung bình còn lại (g)',
            remainingBm: 'Sản lượng còn lại (kg)',
          },
          destination: {
            destinationPond: 'Ao đích đến',
            currentQty: 'Số lượng hiện tại (trước khi san)',
            cycleName: 'Tên chu kỳ nuôi',
            transferQty: 'Số lượng san',
            transferMw: '‘Cân nặng trung bình (g)',
            transferBm: 'Sản lượng (kg)',
            summary: 'Tóm tắt',
          },
        },
      },
      waterQuality: {
        registrationDate: 'Ngày đăng ký đã chọn',
        destinationPonds: 'Ao đích đến',
        types: {
          1: 'Oxy hòa tan',
          2: 'Độ đục',
          3: 'Nhiệt độ nước',
          4: 'Độ mặn',
          5: 'pH',
        },
        add: {
          summary: 'Tóm tắt',
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng hiện tại',
          meanWeight: 'Cân nặng trung bình hiện tại (g)',
          biomass: 'Sản lượng hiện tại (kg)',
          waterQualityType: 'Thông số chất lượng',
          value: 'Giá trị',
        },
        edit: {
          summary: 'Tóm tắt',
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng tôm',
          meanWeight: 'Cân nặng trung bình (g)',
          biomass: 'Sản lượng (kg)',
          waterQualityType: 'Thông số chất lượng',
          value: 'Giá trị',
        },
        list: {
          name: 'Tên',
          zone: 'Vùng',
          status: 'Tình trạng',
          days: 'Số ngày',
        },
      },
      treatment: {
        Search: {
          NoResults: 'Không kết quả',
        },
        Buttons: {
          Confirm: 'Xác nhận',
          ConfirmTreatment: 'Xác nhận',
        },
        add: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng hiện tại',
          meanWeight: 'Cân nặng trung bình hiện tại (g)',
          biomass: 'Sản lượng hiện tại (kg)',
          treatmentType: 'Loại xử lý',
          amount: 'Số lượng',
          summary: 'Tóm tắt',
        },
        edit: {
          destinationPond: 'Ao đích đến',
          cycleName: 'Tên chu kỳ nuôi',
          zone: 'Vùng',
          number: 'Số lượng tôm',
          meanWeight: 'Cân nặng trung bình (g)',
          biomass: 'Sản lượng (kg)',
          treatmentType: 'Loại xử lý',
          amount: 'Số lượng',
          summary: 'Tóm tắt',
        },
      },
    },
    registrationLog: {
      title: 'Hồ sơ đăng ký',
      notFoundMessage: 'Không có hồ sơ được ghi nhận. Vui lòng thử chọn ngày khác hoặc loại hồ sơ khác.',
      filters: {
        fromDate: 'Lọc theo ngày',
        toDate: 'Lọc theo ngày',
        registrationType: 'Lọc theo loại hồ sơ đăng ký',
        showUserRegistrations: 'Chỉ hiện người dùng',
        hideEmptyDays: 'Ẩn ngày trống',
      },
      list: {
        registrationDate: 'Ngày đăng ký',
        logID: 'Log ID',
        eventNumber: 'Event number',
        registrationType: 'Loại đăng ký',
        email: 'Email',
        dateCreated: 'Ngày tạo',
      },
      registrationTypes: {
        stocking: 'Stocking',
        transfer: 'San',
        harvest: 'Thu hoạch',
        feeding: 'Cho ăn',
        treatment: 'Xử lý',
        waterQualitySample: 'Mẫu chất lượng nước',
        meanweightSample: 'Mẫu cân nặng trung bình',
        mortality: 'Mortality',
        feederChange: 'Feeder change',
        aeratorChange: 'Aerator change',
      },
    },
    farmSetup: {
      title: 'Farm Setup',
      tooltip: {
        feeders: 'feeders',
        aerators: 'aerators',
        feedersCapacity: 'feed capacity',
        aeratorsSupported: 'of biomass supported',
      },
      list: {
        name: 'Name',
        zone: 'Zone',
        active: 'Active',
        days: 'No. Days',
        noShrimps: 'No. Shrimps',
        biomass: 'Biomass ({type})',
        avgWeight: 'Avg. Weight (g)',
        feeders: 'Feeders',
        aerators: 'Aerators',
        aeratorSupportedBiomass: 'Aerator sup. biomass ({type})',
        feederSupportedBiomass: 'Feeder sup. biomass ({type})',
      },
      buttons: {
        previousDay: 'Previous Day',
        nextDay: 'Next Day',
        manageAerators: 'Manage Aerators',
        manageFeeders: 'Manage Feeders',
        done: 'Done',
      },
      dialogs: {
        feeders: {
          feedersCapacity: 'of current pond feed demand supported',
          name: 'Name',
          brand: 'Brand',
          noUnits: 'No. of units',
          type: 'Type',
          storageCapacity: 'Storage cap. kg',
          feedingCapacity: 'Feeding cap. kg',
          currentCapacity: 'Current pond biomass: {biomass} kg',
          feeder: 'Feeder',
          addFeeders: 'Add feeder to pond',
          added: '(Added)',
          close: 'Close',
        },
        aerators: {
          aeratorsSupported: 'of current pond biomass supported',
          name: 'Name',
          brand: 'Brand',
          noUnits: 'No. of units',
          type: 'Type',
          horsePower: 'Horsepower / unit',
          supportedBiomass: 'Biomass support / unit',
          currentCapacity: 'Current pond biomass: {biomass} kg',
          aerator: 'Aerator',
          quantity: 'Quantity',
          addAerators: 'Add aerator to pond',
          added: '(Added)',
          close: 'Close',
        },
        registrationDate: 'Registration date',
        addAeratorToPond: 'Add',
        addFeederToPond: 'Add',
      },
      filters: {
        showActive: 'Show active ponds',
        showInactive: 'Show inactive ponds',
        registrationDate: 'Registration date',
        zone: 'Filter on zone',
        selectAll: 'Select all',
        pondType: 'Pond Type',
        poundsOrKg: 'Pounds (lbs) / kg',
        pondTypes: {
          Production: 'Production',
          Raceway: 'Raceway',
          Nursery: 'Nursery',
        },
      },
    },
  },
  selfService: {
    title: 'Self Service',
    feedCatalog: {
      createNewFeed: 'Tạo loại thức ăn mới',
      title: 'Catalog thức ăn',
      filters: {
        showActive: 'Hiện thức ăn đang sử dụng',
        showInactive: 'Hiện thức ăn không sử dụng',
      },
      types: {
        extruded: 'Ép đùn',
        crumble: 'Mảnh',
        pellet: 'Viên',
        liquid: 'Nước',
        soy: 'Soy',
        regular: 'Thông thường',
        functional: 'Chức năng',
      },
      list: {
        feedBrandId: 'ID nhãn hiệu thức ăn',
        feedType: 'Loại thức ăn',
        feedSubType: 'Loại (phụ) thức ăn',
        name: 'Tên',
        size: 'Kích cỡ',
        price: 'Giá',
        createdBy: 'Tạo bởi',
        active: 'Đang hoạt động',
        edit: 'Điều chỉnh',
      },
      createFeedCatalog: {
        dialog: {
          title: 'Cập nhật thức ăn',
          button: 'Lưu',
          inputName: 'Điền tên',
          selectFeedBrand: 'Chọn nhãn hiệu thức ăn',
          selectFeedType: 'Chọn loại thức ăn',
          selectFeedSubType: 'Chọn loại (phụ) thức ăn',
          inputSize: 'Chọn kích cỡ',
          inputPrice: 'Chọn giá (optional)',
          inactive: 'Thức ăn không sử dụng',
          inputCode: 'Điền mã (không bắt buộc)',
          duplicatedCode: 'Mã thức ăn bạn điền đã có sẵn',
        },
      },
      editFeedCatalog: {
        dialog: {
          title: 'Cập nhật thức ăn',
          button: 'Lưu',
          inputName: 'Điền tên',
          selectFeedBrand: 'Chọn nhãn hiệu thức ăn',
          selectFeedType: 'Chọn loại thức ăn',
          selectFeedSubType: 'Chọn loại (phụ) thức ăn',
          inputSize: 'Chọn kích cỡ',
          inputPrice: 'Chọn giá (optional)',
          inactive: 'Thức ăn không sử dụng',
          inputCode: 'Điền mã (không bắt buộc)',
          duplicatedCode: 'Mã thức ăn bạn điền đã có sẵn',
        },
      },
    },
    treatmentCatalog: {
      title: 'Catalog biện pháp xử lý',
      filters: {
        showActive: 'Hiện các biện pháp xử lý đang thực hiện',
        showInactive: 'Hiện các biện pháp xử lý đã dừng',
      },
      types: {
        liquid: 'Liquid',
        powder: 'Powder',
        solid: 'Solid',
        chemical: 'Chemical',
        fertilizer: 'Fertilizer',
        probiotic: 'Probiotic',
        feedAddative: 'Feed Addative',
        antibiotic: 'Antibiotic',
      },
      list: {
        code: 'Code',
        type: 'Loại',
        brand: 'Nhãn hiệu',
        name: 'Tên',
        price: 'Giá',
        treatmentCategory: 'Treatment cat. ID',
        createdBy: 'Tạo bởi',
        active: 'Đang hoạt động',
        edit: 'Chỉnh sửa',
      },
      createTreatmentDialog: {
        dialog: {
          title: 'Tạo biện pháp xử lý mới',
          button: 'Lưu',
          code: 'Điền code',
          type: 'Điền loại xử lý',
          brand: 'Điền nhãn hiệu',
          name: 'Điền tên sản phẩm',
          price: 'Giá',
          treatmentCategory: 'Chọn loại biện pháp xử lý',
          inactive: 'Biện pháp xử lý đã dừng',
          success: 'Biện pháp xử lý đã được tạo',
          duplicatedCode: 'Biện pháp xử lý với code đã có sẵn',
        },
      },
      editTreatmentCatalog: {
        dialog: {
          title: 'Cập nhật biện pháp xử lý',
          button: 'Lưu',
          code: 'Điền code',
          type: 'Chọn loại biện pháp xử lý',
          brand: 'Điền nhãn hàng',
          name: 'Điền tên sản phẩm',
          price: 'Giá',
          treatmentCategory: 'Chọn loại biện pháp xử lý',
          inactive: 'Biện pháp xử lý đã dừng',
          duplicatedCode: 'Biện pháp xử lý với code đã có sẵn',
        },
      },
    },
    aerators: {
      title: 'Aerators',
      filters: {
        showActive: 'Show active aerators',
        showInactive: 'Show inactive aerators',
      },
      list: {
        name: 'Name',
        brand: 'Brand',
        type: 'Type',
        horsepower: 'Horsepower',
        biomassSupported: 'Supported Biomass (kg)',
        active: 'Active',
        edit: 'Edit',
      },
      types: {
        electric: 'Electric',
        diesel: 'Diesel',
        paddleWheel: 'Paddle Wheel',
        injection: 'Injection',
        diffusion: 'Diffusion',
      },
      createAerator: {
        btnTitle: 'Create aerator',
        dialog: {
          title: 'Create new aerator',
          name: 'Name',
          brand: 'Brand (optional)',
          type: 'Type',
          subType: 'Sub-type',
          horsepower: 'Horsepower',
          biomassSupported: 'Supported biomass',
          button: 'Save',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      updateAerator: {
        dialog: {
          title: 'Update aerator',
          name: 'Name',
          brand: 'Brand (optional)',
          type: 'Type',
          subType: 'Sub-type',
          horsepower: 'Horsepower',
          biomassSupported: 'Supported biomass',
          inactive: 'Inactive Aerator',
          button: 'Save',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
    },
    feeders: {
      title: 'Feeders',
      filters: {
        showActive: 'Show active feeders',
        showInactive: 'Show inactive feeders',
      },
      list: {
        name: 'Name',
        brand: 'Brand',
        storageCapacity: 'Storage cap.',
        supportedBiomass: 'Supported biomass',
        active: 'Active',
        edit: 'Edit',
        kgFeeder: 'kg/feeder',
      },
      createFeeder: {
        btnTitle: 'Create feeder',
        dialog: {
          title: 'Create new feeder',
          name: 'Name',
          brand: 'Brand',
          storageCapacity: 'Storage capacity',
          supportedBiomass: 'Supported biomass',
          button: 'Save',
          endAdornment: '{unit}/feeder',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      updateFeeder: {
        dialog: {
          title: 'Update feeder',
          name: 'Name',
          brand: 'Brand',
          storageCapacity: 'Storage capacity',
          supportedBiomass: 'Supported biomass',
          inactive: 'Inactive Feeder',
          button: 'Save',
          endAdornment: '{unit}/feeder',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
    },
  },
  form: {
    errors: 'Errors',
    rules: {
      required: 'This field is required',
      moreThanZero: 'Value must be larger than 0',
      minValue: 'Value must be greater than {min}',
      maxValue: 'Value must be less than {max}',
      between: 'Value must be between {lower} and {upper}',
      positive: 'Value must not be negative',
      packaging: 'No value from Packaging',
      multiple: 'Product quantity should be a multiple of {packaging}',
      largerThen: 'Value is larger then {field}',
      duplication: 'Same order product exists',
      errorMessage: 'Value must be greater than 0',
      invalidValue: 'Value is not valid',
    },
    buttons: {
      edit: 'Edit Report',
      nextFish: 'Next Fish',
      cancel: 'Cancel',
      confirm: 'Confirm',
      downloadFile: 'Download',
      chooseFile: 'Choose file',
    },
    fileUpload: {
      heading: 'Export information',
      listRow: {
        fileName: 'File name',
        source: 'Source',
        destination: 'Destination',
        version: 'Version',
        exportDate: 'Export date',
        periodStart: 'Period start',
        periodEnd: 'Period end',
        companies: 'Companies',
      },
      options: {
        field: 'Field',
        value: 'Value',
        siteName: 'Site name',
        lastDate: 'Last Date Of Registration',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
    },
  },
  snackbar: {
    success: {
      default: 'Success',
      calc: 'Please run calibration',
      scenarioRunStarted: 'Scenario run started.',
      scenarioResultsReady: 'Scenario results are ready.',
      viewResults: 'View results',
    },
    errors: {
      default: 'Error',
    },
    warning: {
      default: 'Warning',
    },
  },
  dialog: {
    delete: {
      title: 'Are you sure?',
    },
  },
  benchmarkAnalytics: {
    growth: 'Tăng trưởng',
    placeholderOne: 'Tab giữ chỗ 1',
    placeholderTwo: 'Tab giữ chỗ 2',
    growthPage: {
      filters: {
        day: 'Ngày',
        week: 'Tuần',
        month: 'Tháng',
        quarter: 'Quý',
        fullCycle: 'Toàn chu kỳ',
        finalStage: 'Giai đoạn cuối',
        fromDate: 'Từ ngày',
        toDate: 'Đến ngày',
        clear: 'Xóa',
        reset: 'Thiết lập lại',
        addFarm: 'Thêm trại để so sánh',
        farmsSelected: 'Đã chọn {count}/{total}',
        farmsAll: 'Tất cả ({total})',
        selectAll: 'Chọn tất cả',
        groupingLabel: 'Nhóm theo thời gian',
        variantLabel: 'Biến thể tăng trưởng',
      },
      caption: 'Thị trường: {market} điểm dữ liệu ngày | Công ty: {company}',
      kpi: {
        periods: 'Số kỳ',
        periodsCaption: '{count} kỳ theo {grouping} trong khoảng',
        companyAvg: 'Tăng trưởng TB của công ty (g/ngày)',
        marketAvg: 'Tăng trưởng TB thị trường {market} (g/ngày)',
        weightedOverall: 'bình quân gia quyền tổng thể',
        periodsMatched: '{count} kỳ trùng khớp',
        overallDelta: 'Δ tổng thể so với thị trường',
        aboveMarket: 'cao hơn thị trường',
        belowMarket: 'thấp hơn thị trường',
        equalMarket: 'bằng thị trường',
      },
      chart: {
        title: 'Tăng trưởng ({variant}) so với thị trường',
        yAxis: 'Tốc độ tăng trưởng (g/ngày)',
        xAxis: 'Kỳ',
        thisCompany: 'Công ty này',
        marketAvg: 'TB thị trường {market}',
        noData: '(không có dữ liệu)',
        allHidden: 'Tất cả chuỗi dữ liệu đang bị ẩn.',
        empty: 'Không có dữ liệu cho lựa chọn này.',
        error: 'Không thể tải dữ liệu tăng trưởng.',
        retry: 'Thử lại',
      },
      table: {
        title: 'Benchmark tăng trưởng — {variant}',
        period: 'Kỳ',
        company: 'Tăng trưởng công ty (g/ngày)',
        market: 'TB thị trường (g/ngày)',
        farmGrowth: 'Tăng trưởng {farm}',
        delta: 'Δ so với thị trường',
        periodsFooter: '{count} kỳ',
        scrollLeft: 'Cuộn sang trái một cột',
        scrollRight: 'Cuộn sang phải một cột',
      },
      unit: {
        gPerDay: 'g/ngày',
      },
    },
  },
  sidebar: {
    overview: 'Overview',
    deliveryBoard: 'Delivery Board',
    orderFeed: 'Order Feed',
    fishCheck: 'Fish Check',
    planningPrognosis: 'Planning & Prognosis',
    reports: 'Reports',
    seaCloudFileUpload: 'SeaCloud File Upload',
    bluViuNutrition: 'bluViu Nutrition',
    feedManagement: 'Feed Management',
    siteSettings: 'Site Settings',
    profilesStrategies: 'Profiles & Strategies',
    fileSharing: 'Files',
    logout: 'Logout',
    settings: 'Settings',
    shrimpDataUpload: 'Shrimp Data Upload',

    productionSystems: 'Production Systems',
    benchmarkAnalytics: 'Benchmark Analytics',
    selfService: 'Self Service',

    playground: 'Playground',
  },
  footer: {
    copyright: 'Copyright © Cargill, Incorporated. All Rights Reserved.',
    copyrightUk: 'Copyright © 2022 Cargill, Incorporated. All Rights Reserved.',
    ukAddress: 'EWOS Limited. Registered Office: 7th Floor, 33 King William Street, London, EC4R 9AT',
    ukRegister: 'Registered in England and Wales, Company No: 01635854',
  },
  MobileAppBanner: {
    title: 'Nhận ứng dụng BluViu',
    description: 'Tận hưởng trải nghiệm tốt hơn trên điện thoại của bạn với ứng dụng di động của chúng tôi.',
  },
};
